export const cn: { [key: string]: string } = {
  subscribe_with_click: '一键订阅',
  subscribe: '一键订阅',
  minimum_number_characters: '最少 2 个字符',
  request_details: '请求详情',
  form_title: '我们将很快与您联系',
  form_required: '标有 * 的字段为必填项',
  form_name_placeholder: '姓名',
  form_email_placeholder: '电子邮件',
  form_phone_placeholder: '电话号码',
  form_company_placeholder: '公司',
  form_submit: '提交',
  form_1: '我同意按照',
  form_2: '隐私政策',
  validation_privacy_policy: '请接受隐私政策',
  validation_phone: '电话号码无效',
  validation_email: '电子邮件格式无效',
  validation_required: '必填字段未填写',
  submit_error: '保存表单时发生错误',
  footer_1: '我们的合作伙伴：',
  footer_2: '方法',
  footer_3: '产品',
  footer_4: '联系方式：',
  footer_5: '公司信息',
  footer_6: '隐私政策',
  footer_7: '市场调研',
  about_us_1: '4Service 企业社会责任',
  about_us_2:
    '源自我们团队每一位成员的心与灵魂。我们竭尽全力，让每位员工都怀有一颗善良的心，并让世界变得更加美好',
  about_us_3: '4Service 企业社会责任',
  about_us_4:
    '源自我们团队每一位成员的心与灵魂。我们竭尽全力，让每位员工都怀有一颗善良的心，并让世界变得更加美好',
  about_us_5: 'Service Mania 商业游戏',
  about_us_6: '我们面向儿童和学生的公益项目',
  about_us_7: '慈善 / 志愿服务',
  about_us_8:
    '孤儿院、养老院以及支持乌克兰军队的志愿服务，这是我们最感动的活动之一',
  about_us_9: '动物福利',
  about_us_10:
    '任何人都可以带着宠物来到我们的办公室。我们支持动物收容所，筹集食物资金，并帮助无家可归的动物找到新家',
  about_us_11: '4Service 集团',
  about_us_12: '是一家专注于客户体验管理的国际研究公司。',
  about_us_13: '我们实施复杂的项目，以提高销售额并推动以客户为中心的企业发展。',
  about_us_14:
    '是一家总部位于奥地利维也纳的国际研究控股公司。公司成立于 2001 年，致力于提升客户及其互动者的生活质量。正因如此，我们选择了“4Service”这个名字，以体现客户服务和卓越品质。',
  about_us_15:
    '4Service 的历史始于乌克兰基辅，作为领先的神秘顾客服务提供商。如今，我们在 52 个国家作为研究公司持续运营，全面分析和优化整个客户体验链。',
  about_us_16: '诞生于服务之名',
  about_us_17: '在乌克兰境外设立的第一个办公室',
  about_us_18: '总部迁至维也纳',
  about_us_19: '欧洲前十客户体验管理机构，MSPA 精英会员',
  about_us_20: '在 9 个国家设立办公室',
  about_us_21: '首批数字化项目，Voicer',
  about_us_22: 'DesignThinkers Academy 合作伙伴',
  about_us_23: '首个全球 CX 项目',
  about_us_24: '使命',
  about_us_25:
    '我们的使命是改善全球客户服务！我们的灵感来源于我们所服务的企业和人们所经历的积极变化。',
  about_us_26: '20+ 年客户体验管理',
  about_us_27: '95 个国家',
  about_us_28: '我们收集并分享全球最佳行业经验',
  about_us_29: '总部位于维也纳',
  about_us_30: '国家。我们收集并分享全球最佳行业经验',
  about_us_31: '服务质量评级',
  about_us_32: '我们跻身欧洲前 10 CX 机构',
  about_us_33: '代表处 / 总部设在奥地利',
  about_us_34: '活跃项目',
  about_us_35: '您的未来工作场所',
  about_us_36: '我们的办公室',
  about_us_37:
    '4Service ™ 致力于为员工打造舒适的工作环境。我们的员工可以选择现场办公、远程办公或混合办公，以实现最高的便利性和生产力。休息室、免费的心理支持和友好的工作氛围。我们欢迎人与宠物。',
  about_us_38: '点燃激情的团队',
  about_us_39:
    '我们的多元化团队致力于倾听客户意见，关注反馈，并共同成长。客户旅程对我们而言，与推出新产品或实现财务目标同样重要。我们的目标是对周边社区产生积极影响，并为客户提供创新和以人为本的解决方案。',
  about_us_40: '全部',
  about_us_41: '管理',
  about_us_42: '全球团队',
  about_us_43: '产品负责人',
  about_us_44: '我们的合作伙伴',
  about_us_45: '我们实施复杂的项目，以提高销售额并推动以客户为中心的企业发展',
  about_us_46:
    '是领先的“以设计为驱动”的专业培训机构之一，遍布 25 个国家，培养并促进创意跨学科团队和社区，以推动积极变革。设计思维能够帮助您开发和提供创新想法，推动变革，并为复杂问题提供解决方案。',
  about_us_47:
    '他们的使命是为团队和个人提供空间和时间，以获得灵感和挑战，通过“实践学习”来增强创造性解决问题的能力，并帮助组织构建必要的环境和思维方式，以启动大胆的创新。',
  about_us_48:
    '是神秘顾客行业公司的代表性行业协会。该协会在全球范围内按地区运作，设有美洲、欧洲/非洲和亚太地区分部。会员公司联合为一个共同体，以通过协同努力和行动加强神秘顾客行业。',
  about_us_49:
    '是一個非營利的會員組織。會員組成的社群深信資料分析、研究和洞察力的潛力，有助於改善社會、組織和每個人的生活。',
  about_us_50:
    'ESOMAR 总部位于荷兰阿姆斯特丹。自 1947 年以来，ESOMAR 通过其会员遍及 130 多个国家。',
  about_us_51:
    '（UCCA）是一个由私人专家和公司组成的专业社区，致力于联络和发展客户服务及联络中心领域。UCCA 的理念是提升联络中心行业的文化，以现代技术和高标准为基础。',
  about_us_52: '乌克兰联络中心协会成立于 2010 年',
  about_us_53:
    '研究全球教育领域的最佳经验，以适应并应用于乌克兰市场。因此，DTEK 学院与世界领先的商学院合作：INSEAD、IE 商学院和斯坦福大学。',
  about_us_54:
    'DTEK 学院专注于在 D.Client School、ID School、Executive Education：创新能源、沟通能力、DX School 数字化项目、有效领导力：Pre-MBA、变革能量等方面发展客户导向和创新文化。',
  about_us_55: 'Sergey Pashkovsky',
  about_us_56: 'Viktoria Skorbota',
  about_us_57: 'Artem Fomin',
  about_us_58: 'Max Papka',
  about_us_59: '国际销售经理',
  bht_1: '品牌健康',
  bht_2: '追踪',
  bht_3: '品牌具有强大的影响力',
  bht_4: '了解您的品牌整体表现如何',
  bht_5: '关于',
  bht_6: '什么是品牌健康追踪？',
  bht_7: '这是一种定期进行的市场研究（每两周、每月等），以获取有关',
  bht_8:
    '品牌在市场上的状态信息，包括知名度、需求、形象、消费者特征、品牌健康状况等。',
  bht_9: '最常购买该品牌',
  bht_10: '忠诚用户',
  bht_11: '三个月内购买该品牌',
  bht_12: '常规 / 回购客户',
  bht_13: '六个月内购买该品牌',
  bht_14: '短期客户',
  bht_15: '一年内购买该品牌',
  bht_16: '长期客户',
  bht_17: '知道该品牌但从未使用/购买',
  bht_18: '了解但非客户',
  bht_19: '从未听说过该品牌',
  bht_20: '未知品牌',
  bht_21: '品牌购买者画像',
  bht_22: '评估长期品牌建设投入的一致性',
  bht_23: '衡量客户对品牌的认知程度',
  bht_24: '展示广告和信息宣传活动的有效性',
  bht_25: '确定高广告投放期对竞争对手销售/营销活动的影响',
  bht_26: '在市场持续变化期间，为企业提供稳定的控制',
  bht_27: '品牌健康追踪能解决哪些问题？',
  bht_28: '申请研究',
  bht_29: '要解决的任务',
  bht_30: '例如，',
  bht_31:
    '如果公司每季度仅需进行一次 BHT 以衡量市场份额，那么在测量广告对客户品牌认知的影响时，应更频繁地进行受访者调查。',
  bht_32: 'CATI',
  bht_33: '面對面',
  bht_53: '訪談',
  bht_34: 'CAWI',
  bht_35: '待解决的任务',
  bht_36: '通过收集信息',
  bht_37: '品牌追踪通常根据目标受众及其触达难度，分为三个阶段：',
  bht_38: '我们使用传统和现代方法收集数据：',
  bht_39:
    '我们采用两种模型：第一种包含简单的指标集，第二种针对更复杂的行业，如食品和服务行业。更复杂的模型涉及包括最多 10 个评估指数的深入研究。',
  bht_40: '我们提供',
  bht_41: '初始数据控制',
  bht_42: '我们覆盖',
  bht_43: '全国范围',
  bht_44: '我们提供解决方案',
  bht_45: '适用于非动态市场/参与者有限的市场（品牌点分析）',
  bht_46: '为什么选择我们？',
  bht_47: '为什么选择我们？',
  bht_50: '较差的结果',
  bht_51: '良好的结果',
  bht_52: '平均结果',
  cases_1: '挑战：如何改善现代汽车展厅的电动汽车购买体验？',
  cases_2: '客户旅程绘制',
  cases_3: '创意构思',
  cases_4: '定性研究',
  cases_5:
    '挑战：应该如何调整门店（包括服务流程、室内设计、品牌认知），以吸引客户对 Oppo 品牌的兴趣？',
  cases_6: '在线客户旅程映射',
  cases_7: 'UI 测试',
  cases_8: '访谈',
  cases_9: '挑战：应该如何调整门店，以吸引客户对 Oppo 品牌的兴趣？',
  cases_10: '定性部分',
  cases_11: '创意构思',
  cases_12: '定量部分',
  cases_13: '客户旅程地图',
  cases_14: '案例',
  cases_15: '全部',
  cases_16: '让我们一起打造您的成功案例',
  csi_1: '客户',
  csi_2: '满意度指数',
  csi_3: '确定消费者',
  csi_4: '满意与不满意的原因',
  csi_5: '客户满意度研究',
  csi_6: '是确定影响客户购买决策的因素、原因和动机，以及目标受众的行为。',
  csi_7: '客户满意度调查',
  csi_8: '显示客户对某一特定服务或产品整体的满意度或不满意程度。',
  csi_9: '满意度调查',
  csi_10: '在公司的现有客户和特定产品/服务的用户中进行。',
  csi_11: '什么是 CSI？',
  csi_12: '客户满意度衡量客户对贵公司提供的产品或服务的期望满足程度。',
  csi_13: '快乐的男人',
  csi_14: '关于',
  csi_15: '识别任何潜在因素',
  csi_16: '可能影响客户满意度',
  csi_17: '确定原因',
  csi_18: '导致商品和服务需求增长/下降的原因',
  csi_19: '优化公司的',
  csi_20: '业务流程',
  csi_21: '使其适应',
  csi_22: '现代消费者的需求',
  csi_23: '制定有效的广告信息',
  csi_24: '并根据客户需求定位产品',
  csi_25: '待解决的任务',
  csi_26: '客户满意度调查能解决哪些问题',
  csi_27: '拿着手机的男人',
  csi_28: '我们构建数学模型',
  csi_29: '分析可能影响客户满意度/客户忠诚度的因素（回归分析）',
  csi_30: '优化',
  csi_31: '公司的业务流程',
  csi_32: '我们计算客户满意度指数',
  csi_33: '（CSI）并将其与声明性指数进行比较',
  csi_34: '我们进行研究',
  csi_35: '涵盖 B2B 和 B2C 细分市场。',
  csi_36: '我们的问卷由一支分析团队开发',
  csi_37: '专门针对客户的个性化项目',
  csi_38: '为什么选择我们',
  csi_39: '为什么选择我们？',
  csi_40: '信息收集方法：',
  main_1: '我们的客户通过学习他们客户的经验来改善财务业绩',
  main_2: 'CX 研究与咨询服务：全面了解您的业务',
  main_3: '探索我们的解决方案和工具，支持您的业务',
  main_4: '产品',
  main_5: '定性研究是收集和分析非数字数据，以理解概念、观点或经验',
  main_6: '定量研究方法是通过投票、问卷和调查收集数据的客观测量和数值分析',
  main_7:
    '神秘顾客调查是一种市场研究技术，用于衡量和监测客户与公司或组织在预定场景中的互动',
  main_8: '反馈管理系统。客户反馈管理系统，让客户的声音汇集于一体',
  main_9: 'AI 驱动的内容智能平台，提供受众洞察',
  main_10: '绩效管理软件。通过游戏化应用提高销售额',
  main_11: '价格监测是收集、处理和分析竞争对手价格的过程',
  main_12: '服务设计是通过与人们共度时间来理解他们对产品或服务的需求和期望',
  main_13: '我们的分析团队采用最先进和最基本的方法，并已在众多客户中验证成功',
  main_14: '方法论',
  main_15: '客户旅程地图',
  main_16:
    '客户旅程映射 (CJM) 旨在定义目标受众，理解他们的需求和环境，并制定计划以提供引人入胜的体验',
  main_17: 'CJM',
  main_18: '净推荐值',
  main_19:
    '净推荐值 (NPS) 是客户体验衡量的黄金标准，基于一个问题：您有多大可能推荐该组织/产品/服务？',
  main_20: 'NPS',
  main_21: '品牌健康追踪',
  main_22:
    '品牌健康追踪 (BHT) 研究可衡量品牌在认知度、使用情况、品牌定位和品牌表现方面的表现',
  main_23: 'BHT',
  main_24: '人力资源研究',
  main_25: '人力资源研究用于评估 HR 实践和绩效，并提供当前发展和管理的详细分析',
  main_26: 'HR 研究',
  main_27: '客户满意度指数',
  main_28:
    '客户满意度指数 (CSI) 是一个分数，表示客户对公司产品/服务的满意程度。',
  main_29: 'CSI',
  main_30: 'UX 测试',
  main_31:
    '可用性 (UX) 测试是观察真实用户如何与网站、应用或其他产品互动，并分析他们的行为和反应',
  main_32: '为什么选择我们',
  main_33: '我们的使命是帮助企业提供高效的客户体验',
  main_34: '专注于质量',
  main_35: '我们的研究数据受到质量控制',
  main_36: '我们向客户提供所有数据集',
  main_37: '成本效益',
  main_38: '我们的经验、资源和精简的',
  main_39: '业务流程可以帮助您节省资金和时间',
  main_40: '智能解决方案',
  main_41: '我们采用多种技术',
  main_42: '和工具包来解决您的特定问题',
  main_43: '专注于质量',
  main_44: '我们的研究数据受到质量控制',
  main_45: '我们向客户提供所有数据集',
  main_46: '成本效益',
  main_47: '我们的经验、资源和精简的',
  main_48: '业务流程可以帮助您节省资金和时间',
  main_49: '智能解决方案',
  main_50: '我们采用多种技术',
  main_51: '和工具包来解决您的特定问题',
  main_52: '仓储式零售',
  main_53: '电子产品',
  main_54: '奢侈品/高端品牌',
  main_55: '餐饮与酒店业',
  main_56: '零售',
  main_57: '汽车行业',
  main_58: '时尚',
  main_59: '银行',
  main_60: '旅游与休闲',
  main_61: '手表与珠宝',
  main_62: '家居与家电',
  main_63: '博客',
  main_64: '访问博客，阅读更多有趣的文章',
  main_65: '零售审计',
  main_66:
    '收集有关您的商店或品牌的详细数据，分析增长障碍，并制定有效策略以克服它们',
  cjm_1: '客户',
  cjm_2: '旅程地图',
  cjm_3: '进入客户的世界，分享他们的体验',
  cjm_4: '什么是客户旅程地图？',
  cjm_5:
    'CJM 通过各种渠道并在特定时间内，提供消费者与产品、服务、公司或品牌互动的可视化历史。',
  cjm_6:
    '这使公司能够客观分析客户互动体验，发现并消除出现的障碍，并提供改进产品的建议。',
  cjm_7: '目标受众确定与细分',
  cjm_8: '识别客户互动阶段',
  cjm_9: '识别主要客户互动渠道',
  cjm_10: '客户体验研究',
  cjm_11: '分析障碍并提出优化假设',
  cjm_12: '执行和测试假设',
  cjm_13: '设计客户旅程地图包括以下步骤：',
  cjm_14: '客户旅程地图将展示：',
  cjm_15:
    'CJM 通过各种渠道并在特定时间内，提供消费者与产品、服务、公司或品牌互动的可视化历史。',
  cjm_16: '我们确保团队合作',
  cjm_17: '分析师与设计师之间的协作',
  cjm_18: '我们提供个性化',
  cjm_19: '针对每位客户的独特方法',
  cjm_20: '我们能够整体提升',
  cjm_21: '客户对服务/产品的满意度，并最终提高他们对公司的忠诚度',
  cjm_22: '我们保证',
  cjm_23: '优化消费者路径，同时考虑公司的业务流程',
  cjm_24: '我们为客户提供',
  cjm_25:
    '使用多种研究方法的机会：CATI、CAWI、焦点小组、深度访谈、专家访谈、人种学研究等。',
  cjm_26: '为什么选择我们？',
  methods_hr_1: '人力资源研究',
  methods_hr_2: '获得关于您的团队的客观见解，并找到提升人力资源绩效的方法',
  methods_hr_3: '您可能需要 HR 研究的一些原因',
  methods_hr_4: '受访员工的比例',
  methods_hr_5: '已实施的人力资源项目',
  methods_hr_6: '已进行的员工培训',
  methods_hr_7: '欧洲领先的客户体验与员工研究公司',
  methods_hr_8: '4service HR 研究数据',
  methods_hr_9:
    '识别公司员工生命周期各阶段（招聘/入职/职业发展/再认证）的问题和薄弱环节',
  methods_hr_10: '了解哪些情况值得加薪和奖金',
  methods_hr_11: '需要预测或提供员工不满的解决方案',
  methods_hr_12:
    '通过人力资源研究，可以评估新的和现有的人力资源政策、计划和实践方法',
  methods_hr_13: '改善公司员工的心理健康',
  methods_hr_14: '如果您希望通过目标导向的方法提高生产力',
  methods_hr_15: '如果您拥有国际和/或远程团队，并需要有效管理',
  methods_hr_16: '了解您的雇主品牌对潜在员工的吸引力',
  methods_hr_17: '员工满意度',
  methods_hr_18: '雇主品牌研究',
  methods_hr_19: '文化多样性',
  methods_hr_20: '薪酬与工资计划',
  methods_hr_21: '团队参与度和忠诚度',
  methods_hr_22: '受保护类别员工',
  methods_hr_23: '研究领域',
  methods_hr_24: '解决方案 1',
  methods_hr_25: 'eNPS、员工满意度、员工忠诚度',
  methods_hr_26: '我们衡量的内容：',
  methods_hr_27: '忠诚度：',
  methods_hr_28: '员工忠诚度、未来行为预测、影响忠诚度因素的权重确定',
  methods_hr_29: '投入度：',
  methods_hr_30: '员工对工作的投入程度，对结果和成就的兴趣',
  methods_hr_31: '参与度：',
  methods_hr_32: '识别员工价值观与公司价值观',
  methods_hr_33: '信任 360：',
  methods_hr_34: '对管理层、同事、下属的信任，对雇主战略和政策的信任',
  methods_hr_35: '满意度：',
  methods_hr_36: '为每家公司定义独特因素，评估影响忠诚度的关键因素的满意度',
  methods_hr_37: '解决方案 2',
  methods_hr_38: '雇主品牌建设',
  methods_hr_39: '内部雇主',
  methods_hr_40: '品牌分析（员工、利益相关者、内部招聘人员和人力资源专家调查）',
  methods_hr_41: '外部雇主分析',
  methods_hr_42: '（竞争对手 EVP 分析、外部招聘人员调查、求职者调查）',
  methods_hr_43: '品牌认知度与声誉',
  methods_hr_44: '分析',
  methods_hr_45: '雇主存在',
  methods_hr_47: '雇主参考',
  methods_hr_48: '收集',
  methods_hr_49: '竞争基准分析',
  methods_hr_50: '在关键因素上的比较，例如',
  methods_hr_51: '薪资，',
  methods_hr_52: '工作环境、氛围、工作性质',
  methods_hr_53: '需求和期望分析',
  methods_hr_54: '求职者的',
  methods_hr_55: '深度访谈，',
  methods_hr_56: '案头研究和定量研究',
  methods_hr_57: '解决方案 3',
  methods_hr_58: '员工旅程地图/神秘员工',
  methods_hr_59: '构建求职者旅程，识别',
  methods_hr_60: '搜索的主要阶段、沟通渠道、筛选标准及求职者评估',
  methods_hr_61: '监控所有阶段',
  methods_hr_62: '及与神秘求职者的沟通渠道（仅预约面试、进行面试、在公司实习）',
  methods_hr_63: '识别',
  methods_hr_64: '招聘和入职流程中的薄弱环节',
  methods_hr_65: '改进建议，',
  methods_hr_66: '与行业领导者的基准对比',
  mystery_shopping_1: '神秘',
  mystery_shopping_2: '购物',
  mystery_shopping_3: '通过真实客户评估您的服务',
  mystery_shopping_4: '检查标准，评估您的员工，更贴近您的客户',
  mystery_shopping_5:
    '我们是欧洲领先的专业神秘顾客服务提供商协会（MSPA Europe）的精英成员',
  mystery_shopping_6: '的经验',
  mystery_shopping_7: '每月访问次数',
  mystery_shopping_8: '全球神秘顾客',
  mystery_shopping_9: '活跃项目',
  mystery_shopping_10: '办公室，总部位于奥地利',
  mystery_shopping_11: '欧洲神秘顾客服务提供商',
  mystery_shopping_12: '服务质量评级',
  mystery_shopping_13: '问卷调查',
  mystery_shopping_14: '软件',
  mystery_shopping_15: '顾客档案',
  mystery_shopping_16: '验证与异议',
  mystery_shopping_17: '分析',
  mystery_shopping_18:
    '通过这 5 个步骤，我们的公司 4Service 保证神秘顾客服务的质量',
  mystery_shopping_19: '计划',
  mystery_shopping_20: '4Service 神秘顾客计划的 5 大要素',
  mystery_shopping_21: '问卷调查：',
  mystery_shopping_22: '您的计划核心',
  mystery_shopping_23: '该计划的这一部分对所有利益相关者可见',
  mystery_shopping_24: '对于高层管理人员。',
  mystery_shopping_25: '展示所有重要步骤和流程细节',
  mystery_shopping_26: '对于员工。',
  mystery_shopping_27: '反映雇主对他们的期望',
  mystery_shopping_28: '对于神秘顾客。',
  mystery_shopping_29: '清晰且结构化，避免混淆和偏差',
  mystery_shopping_30: 'Shopmetrics 软件：',
  mystery_shopping_31: '用户友好且创新',
  mystery_shopping_32: '优势：',
  mystery_shopping_33: '可集成',
  mystery_shopping_34: '到您的业务流程和软件',
  mystery_shopping_35: 'GDPR 驱动的',
  mystery_shopping_36: '隐私管理工具包',
  mystery_shopping_37: '详细的',
  mystery_shopping_38: '法律合规方案',
  mystery_shopping_39: '报告',
  mystery_shopping_40: '生成器',
  mystery_shopping_41: '管理',
  mystery_shopping_42: '访问级别',
  mystery_shopping_43: '大多数问卷',
  mystery_shopping_44: '可在一小时内完成',
  mystery_shopping_45: '顾客档案：',
  mystery_shopping_46: '全球 200,000+ 神秘顾客',
  mystery_shopping_47:
    '主要标准：最大程度接近您的目标受众，具有与您的公司或竞争对手的经验',
  mystery_shopping_48: '顾客培训：',
  mystery_shopping_49: '入门培训测试',
  mystery_shopping_50: 'Skype/电话面试',
  mystery_shopping_51: '评估测试（可选）',
  mystery_shopping_52: '验证与异议',
  mystery_shopping_53: '验证',
  mystery_shopping_54: '系统',
  mystery_shopping_55: '100% 报告',
  mystery_shopping_56: '由验证团队审核',
  mystery_shopping_57: '额外通话',
  mystery_shopping_58: '用于澄清',
  mystery_shopping_59: '音频记录',
  mystery_shopping_60: '访问后记录最重要的问题',
  mystery_shopping_61: '员工欺诈',
  mystery_shopping_62: '预防系统',
  mystery_shopping_63: '异议',
  mystery_shopping_64: '系统',
  mystery_shopping_65: '任何顾客的评估',
  mystery_shopping_66: '员工可直接在网站上提出异议',
  mystery_shopping_67: '每个异议',
  mystery_shopping_68: '都会由当地验证团队审查并回应',
  mystery_shopping_69: '您可以查看统计数据',
  mystery_shopping_70: '关于异议',
  mystery_shopping_71: '分析。',
  mystery_shopping_72: '报告以面对面方式呈现，并包含：',
  mystery_shopping_73: '公司的',
  mystery_shopping_74: '痛点和关注点',
  mystery_shopping_75: '动态',
  mystery_shopping_76: '按部门和区域',
  mystery_shopping_77: '相关性',
  mystery_shopping_78: '服务标准符合度与客户满意度之间的',
  mystery_shopping_79: '基准分析',
  mystery_shopping_80: '与竞争对手的比较',
  mystery_shopping_81: '实用的',
  mystery_shopping_82: '服务改进建议',
  mystery_shopping_83: '我们的不同之处？',
  mystery_shopping_84: '我们开展创意研讨会',
  mystery_shopping_85:
    '我们不仅提供改进建议，还与您共同寻找实际的服务问题解决方案。',
  mystery_shopping_86: '创意研讨会是一种强大的工具，帮助我们：',
  mystery_shopping_87: '制定产品或服务改进方向',
  mystery_shopping_88: '探索新的收入来源机会和商业策略',
  mystery_shopping_89: '寻找客户导向型挑战的解决方案',
  mystery_shopping_90: '将客户的痛点转化为愉悦体验',
  mystery_shopping_91: '我们进行视频访谈',
  mystery_shopping_92: '我们不仅收集问卷，还获取顾客的实时评论',
  mystery_shopping_93: '这样做的目的是：',
  mystery_shopping_94: '我们的主持人将进行深入访谈并提供有效反馈',
  mystery_shopping_95: '从客户的角度体验服务',
  mystery_shopping_96: '增强您的内容营销策略',
  mystery_shopping_97: '预测客户行为',
  mystery_shopping_98: '我们设计客户旅程地图',
  mystery_shopping_99:
    '客户旅程地图帮助我们站在客户的角度，理解他们的需求和挑战。',
  mystery_shopping_100: '创建客户旅程的最佳方式是：',
  mystery_shopping_101: '从客户的角度体验服务',
  mystery_shopping_102: '增强您的内容营销策略',
  mystery_shopping_103: '预测客户行为',
  mystery_shopping_104: '识别服务或沟通中的空白',
  mystery_shopping_105: '我们提供不同类型的神秘顾客服务',
  mystery_shopping_106: '神秘顾客类型',
  mystery_shopping_107: '神秘来电者',
  mystery_shopping_108: '拨打您的管理人员和/或呼叫中心，以评估电话服务质量',
  mystery_shopping_109: '奢侈品神秘顾客',
  mystery_shopping_110: '由特定类别的神秘顾客在奢华场所进行服务检查',
  mystery_shopping_111: '竞争对手访问',
  mystery_shopping_112: '最简单的方法来了解您的竞争对手如何运营',
  mystery_shopping_113: '神秘员工',
  mystery_shopping_114: '帮助您了解员工的整个旅程（招聘、适应、办公室流程等）',
  mystery_shopping_115: '激励访问',
  mystery_shopping_116: '用于促进额外服务和/或产品的推荐，或特定产品的销售',
  mystery_shopping_117: '在线神秘顾客',
  mystery_shopping_118: '模拟并衡量客户在您的在线商店、网站或应用程序中的体验',
  mystery_shopping_119: '销售与促销检查',
  mystery_shopping_120: '帮助识别促销在各个地点的展示情况及其有效性',
  mystery_shopping_121: '购买与退货访问',
  mystery_shopping_122: '帮助反映从购买到退货的整个流程，以改善客户体验',
  mystery_shopping_123: '> 20 年',
  nps_1: '净推荐值',
  nps_2: '评分',
  nps_3: '衡量、跟踪并提高客户忠诚度',
  nps_4: '他们的评分范围为 0 到 6。',
  nps_5:
    '他们可能有过不佳的体验，不太可能再次购买您的产品，甚至可能劝阻他人购买。',
  nps_6: '这些受访者的评分在 7 到 8 之间。',
  nps_7: '他们对您的服务感到满意，但不足以被视为推广者。',
  nps_8: '这些受访者的评分为 9 或 10。',
  nps_9: '这意味着他们愿意向朋友或同事推荐您，从而成为您的宣传者。',
  nps_10: '什么是 NPS？',
  nps_11: '它通过一个简单的问题衡量客户的感知：',
  nps_12: '您推荐 [组织/产品/服务] 给朋友或同事的可能性有多大？',
  nps_13: '我的公司需要它吗？',
  nps_14: 'NPS 是您的可持续增长指标',
  nps_15: '理解客户忠诚度的动态变化',
  nps_16: '激励您的员工',
  nps_17: '了解客户与不同产品的关系',
  nps_18: '比较客户如何看待您和您的竞争对手',
  nps_19: 'NPS 可以用来做什么？',
  nps_20: 'NPS 适用于哪些类型的企业？',
  nps_21: '信息收集方法：',
  nps_22: '我们在 NPS 研究中的建议',
  nps_23: '这意味着我们制定指南，将贬损者转化为推广者',
  nps_24: '我们采用“闭环”方法',
  nps_25: 'NPS 是一种跟踪研究，我们跟踪客户忠诚度的变化',
  nps_26: '我们监测动态变化',
  nps_27: '我们建议始终评估您的细分市场中的竞争对手，以进行更深入的分析',
  nps_28: '竞争对手评估',
  price_monitoring_1: '价格监测',
  price_monitoring_2: '零售监测',
  price_monitoring_3: '通过监测竞争对手价格，提高销售潜力并优化您的定价策略',
  price_monitoring_4: '4Service 在全球范围内提供价格监测服务已超过 20 年',
  price_monitoring_5:
    '我们的专业内部审核员团队能在短时间内完成价格监测，使我们能快速响应竞争对手价格变动',
  price_monitoring_6: '我们的价格监测服务能帮助您解决的挑战',
  price_monitoring_7: '评估竞争对手的定价',
  price_monitoring_8: '和产品策略',
  price_monitoring_9: '监测促销活动',
  price_monitoring_10: '和特别优惠',
  price_monitoring_11: '监测市场状况',
  price_monitoring_12: '和市场环境',
  price_monitoring_13: '检查和控制销售网点',
  price_monitoring_14: '确保特殊设备和商品的展示',
  price_monitoring_15: '管理产品',
  price_monitoring_16: '在商业渠道中的流通',
  price_monitoring_17: '优化条件',
  price_monitoring_18: '以更好地与供应商、经销商合作',
  price_monitoring_19: '测量货架空间，',
  price_monitoring_20: '评估商品定位、库存情况',
  price_monitoring_21: '关键指标和监测标准',
  price_monitoring_22: '所有数据都整合在一个界面中，包括：',
  price_monitoring_23: '产品名称',
  price_monitoring_24: '和品牌类别',
  price_monitoring_25: '促销材料',
  price_monitoring_26: '的可用性',
  price_monitoring_27: '价格',
  price_monitoring_28: '和促销优惠的可用性',
  price_monitoring_29: '货架',
  price_monitoring_30: '大小',
  price_monitoring_31: '产品',
  price_monitoring_32: '陈列',
  price_monitoring_33: 'SKU',
  price_monitoring_34: '正面展示',
  price_monitoring_35: '包装类型',
  price_monitoring_36: '的规格',
  price_monitoring_37: '其他',
  price_monitoring_38: '一般信息',
  price_monitoring_39: '项目前分析：',
  price_monitoring_40: '我们研究',
  price_monitoring_41: '贵公司的定价和产品策略、行业标准及商业实践',
  price_monitoring_42: '我们提供',
  price_monitoring_43: '快速培训、测试和审核员认证',
  price_monitoring_44: '我们定制化',
  price_monitoring_45: '并设置软件',
  price_monitoring_46: '现场工作：',
  price_monitoring_47: '访问零售',
  price_monitoring_48: '网点',
  price_monitoring_49: '报告：',
  price_monitoring_50: '我们的分析团队',
  price_monitoring_51: '在公司的个人账户中准备在线报告',
  price_monitoring_52: '我们提供',
  price_monitoring_53:
    '完整的照片报告、PPT 报告、Excel 报告，涵盖地区类型、连锁名称、网点地址',
  price_monitoring_54: '如何',
  price_monitoring_55: '运作',
  price_monitoring_56: '个别折扣的规模',
  price_monitoring_57: '成本计算',
  price_monitoring_58: '个别奖励的规模',
  price_monitoring_59: '忠诚度计划',
  price_monitoring_60: '等。',
  price_monitoring_61: '我们使用专业软件：',
  price_monitoring_62: 'PRADATA、Shopmetrics，并提供全面的技术支持',
  price_monitoring_63: '快速部署',
  price_monitoring_64: '和扩展（从第一天开始）',
  price_monitoring_65: '所有数据均由',
  price_monitoring_66: '照片和 GPS 标记确认',
  price_monitoring_67: '我们拥有足够数量',
  price_monitoring_68: '的现场代理，可覆盖任何国家',
  price_monitoring_69: '我们可以处理',
  price_monitoring_70: '大量数据',
  price_monitoring_71: '个别价格监测',
  price_monitoring_72: '如果您的产品复杂，我们可以帮助您制定定价策略',
  price_monitoring_73: '我们可以监测特定竞争对手的价格，例如：',
  price_monitoring_74: '低',
  price_monitoring_75: '成本',
  price_monitoring_76: '高',
  price_monitoring_77: '效率',
  price_monitoring_78: 'Excel 报告',
  price_monitoring_79: 'PPT 报告',
  price_monitoring_80: 'BI 报告',
  price_monitoring_81: '竞争对手的定价数据帮助您做出最佳定价决策',
  price_monitoring_82:
    '我们提供完整的照片报告、PPT 报告、Excel 报告，涵盖地区类型',
  qualitative_research_1: '定性',
  qualitative_research_2: '研究',
  qualitative_research_3: '通过观察客户的行为和语言来收集、分析和解释数据',
  qualitative_research_4: '价值观',
  qualitative_research_5: '行为',
  qualitative_research_6: '背景',
  qualitative_research_7: '期望',
  qualitative_research_8: '环境',
  qualitative_research_9: '恐惧/障碍',
  qualitative_research_10: '客户选择的目的是什么？',
  qualitative_research_11: '使用手机的男子',
  qualitative_research_12: '品牌',
  qualitative_research_13: '类别',
  qualitative_research_14: '广告',
  qualitative_research_15: '产品',
  qualitative_research_16:
    '定性方法的独特之处在于，它们使我们能够理解消费者行为的原因和动机',
  qualitative_research_17: '分析消费者对特定现象的态度',
  qualitative_research_18: '个体观点和经验',
  qualitative_research_19: '无法通过调查研究的主题',
  qualitative_research_20: '敏感话题',
  qualitative_research_21: '难以接触的受众',
  qualitative_research_22: '复杂的地理范围',
  qualitative_research_23: '深入访谈适用于：',
  qualitative_research_24: '深入访谈',
  qualitative_research_25:
    '深入访谈是一种定性研究技术，涉及与受访者进行个别访谈，以探讨他们对特定想法、项目或情况的看法。深入访谈能够深入挖掘个体的经验/感知/实践。',
  qualitative_research_26: '目标：',
  qualitative_research_27: '描述社会和文化规范',
  qualitative_research_28: '难以接触的受众',
  qualitative_research_29: '共享和比较（Morgan）通过调查研究',
  qualitative_research_30: '无法通过调查研究的主题',
  qualitative_research_31: '深入焦点小组适用于：',
  qualitative_research_32: '焦点小组',
  qualitative_research_33:
    '深入探讨个别会面、动态讨论以及在小组主持人影响下的观点交流。',
  qualitative_research_34:
    '通过小组讨论和叙述性数据分析，共享经验和社会规范的洞察。',
  qualitative_research_36: '优势：',
  qualitative_research_37:
    '在各种真实环境中（家庭、销售点、工作场所等）研究消费者的生活方式和行为',
  qualitative_research_38: '寻找新产品开发、包装设计、服务改进等方面的洞察',
  qualitative_research_39: '深入民族志研究适用于：',
  qualitative_research_40: '民族志研究',
  qualitative_research_41:
    '民族志是一种定性研究方法，通过融入特定社区或组织，近距离观察其行为和互动。',
  qualitative_research_42:
    '民族志是一种灵活的研究方法，可帮助深入理解群体的共享文化、习惯和社会动态，但也涉及一定的实践和伦理挑战。',
  qualitative_research_43: '方法：',
  qualitative_research_44:
    '民族志研究是在真实环境中研究消费者及其与产品/服务的互动',
  qualitative_research_45: '与我们合作的优势',
  qualitative_research_46:
    '我们可以找到任何目标受众的受访者，并严格控制招募质量',
  qualitative_research_47: '招募任何复杂程度的受访者',
  qualitative_research_48: '我们的主持人通晓多种语言，并具备引导技巧',
  qualitative_research_49: '专家主持人',
  qualitative_research_50: '线上/线下研究',
  qualitative_research_51: '我们提供音频/视频',
  qualitative_research_52: '录音',
  qualitative_research_53: '我们可以在任何地区开展定性研究',
  quantitative_research_1: '客户满意度研究',
  quantitative_research_2: '针对特定产品或服务（SCI、NPS）',
  quantitative_research_3: '市场细分调查',
  quantitative_research_4: '不同市场的调查',
  quantitative_research_5: '市场研究',
  quantitative_research_6: 'NPS 管理',
  quantitative_research_7: '竞争对手分析',
  quantitative_research_8: '定量',
  quantitative_research_9: '研究',
  quantitative_research_10:
    '基于客观、数值和统计数据的研究方法，用于测试有关人们态度和行为的理论',
  quantitative_research_11: '年',
  quantitative_research_12: '在全球 CX 领域的经验',
  quantitative_research_13: '受访者',
  quantitative_research_14: '小组',
  quantitative_research_15: '个国家',
  quantitative_research_16: '我们在全球范围内开展项目',
  quantitative_research_17: '我们是谁',
  quantitative_research_18:
    '4Service 是一家全球营销研究和 CX 机构，我们为各种企业提供专业的数据收集服务',
  quantitative_research_19: '4Service 数据概览',
  quantitative_research_20: '计算机辅助',
  quantitative_research_21: '网络访谈',
  quantitative_research_22:
    '基于互联网的问卷调查方式，受访者无需采访员帮助即可完成电子问卷。问卷可通过电子邮件发送或在网站上发布。',
  quantitative_research_23: '计算机辅助网络访谈',
  quantitative_research_24: '在大多数情况下',
  quantitative_research_25: '这种方法在成本和时间上最具性价比',
  quantitative_research_26: '该调查方法提供',
  quantitative_research_27: '接触难以触及受众的机会',
  quantitative_research_28: '提供广泛的可能性',
  quantitative_research_29: '可展示视频、音频材料及图片',
  quantitative_research_30: '受访者可以',
  quantitative_research_31: '位于世界任何地方',
  quantitative_research_32: '它允许研究',
  quantitative_research_33:
    '互联网受众的特定行为，主要研究结果可通过 Web 界面实时提供给客户',
  quantitative_research_34: '适用于任何机密性要求，',
  quantitative_research_35:
    '敏感、个人话题或受访者在与采访员交谈时可能不愿回答的问题',
  quantitative_research_36: '150 000+ 受访者小组',
  quantitative_research_37: '我们拥有全球范围内的专属受访者小组',
  quantitative_research_38: '我们处理复杂的查询',
  quantitative_research_39:
    '通过使用补充工具（社交媒体、广告），我们可以找到特定受众并锁定复杂的受访者画像',
  quantitative_research_40: '我们激励我们的受访者',
  quantitative_research_41:
    '我们设计了一套激励机制，通过物质奖励鼓励受访者完成长时间的调查',
  quantitative_research_42: '面对面访谈',
  quantitative_research_43: '使用平板电脑进行访谈',
  quantitative_research_44:
    '这是收集定量数据的主要方法之一，采访员通过严格结构化的问卷直接与受访者沟通。',
  quantitative_research_45:
    '面对面访谈可以在受访者的工作地点、住所、街头或指定销售场所使用平板电脑进行',
  quantitative_research_46: '使用平板电脑进行的面对面访谈',
  quantitative_research_47: '确定',
  quantitative_research_48: '品牌知名度和受欢迎程度',
  quantitative_research_49: '消费者细分',
  quantitative_research_50: '基于购买行为进行分类',
  quantitative_research_51: '分析',
  quantitative_research_52: '广告活动的有效性',
  quantitative_research_53: '客户满意度',
  quantitative_research_54: '测量',
  quantitative_research_55: '确定最佳价格',
  quantitative_research_56: '适用于产品或服务',
  quantitative_research_57: '分析',
  quantitative_research_58: '消费者偏好',
  quantitative_research_59: '研究',
  quantitative_research_60: '消费者的购买行为',
  quantitative_research_61: '评估',
  quantitative_research_62: '市场容量',
  quantitative_research_63: 'DigSee 软件',
  quantitative_research_64: '我们使用带有音频录制和 GPS 功能的专用软件',
  quantitative_research_65: '采访员与督导',
  quantitative_research_66:
    '我们可以用任何语言进行访谈，并翻译成客户所需的语言',
  quantitative_research_67: '抽样',
  quantitative_research_68: '分析部门开发了一套受访者招募系统，以获取最佳结果',
  quantitative_research_69: '计算机辅助',
  quantitative_research_70: '电话访谈',
  quantitative_research_71:
    '通过电话访谈收集定量信息的方法，采用清晰结构化的问卷。',
  quantitative_research_72: '计算机辅助电话访谈',
  quantitative_research_73: '我们拥有自己的呼叫中心',
  quantitative_research_74: '我们使用带有音频录制和 GPS 功能的专用软件',
  quantitative_research_75: '专业话务员',
  quantitative_research_76:
    '我们的话务员通晓多种语言，受过培训，并持续提高技能',
  quantitative_research_77: '数据库',
  quantitative_research_78: '我们使用自己的数据库，同时也可使用客户的数据库',
  quantitative_research_79: 'SLA',
  quantitative_research_80: '我们保证质量，并签订 SLA（服务级别协议）',
  quantitative_research_81: '目标设定',
  quantitative_research_82: '方法论确定',
  quantitative_research_83: '细分与抽样',
  quantitative_research_84: '确定数据收集渠道',
  quantitative_research_85: '创建符合受访者逻辑的问卷',
  quantitative_research_86: '数据收集过程',
  quantitative_research_87: '质量保障',
  quantitative_research_88: '分析技术',
  quantitative_research_89: '数据处理',
  quantitative_research_90: '调查设计',
  quantitative_research_91: '采访员的 GPS 位置跟踪',
  quantitative_research_92: '数据验证',
  quantitative_research_93: '问卷编程与测试',
  quantitative_research_94: '数据有效性检查',
  quantitative_research_95: '遵循 GDPR 要求的音频录制',
  quantitative_research_96: '研究人员的培训与能力',
  quantitative_research_97: '质量保证',
  quantitative_research_98: '因子分析',
  quantitative_research_99: '细分',
  quantitative_research_100: '感知映射',
  quantitative_research_101: '相关性分析',
  quantitative_research_102: '转化模型',
  quantitative_research_103: 'Jaccard 相似系数',
  quantitative_research_104: '聚类分析',
  quantitative_research_105: '等等',
  quantitative_research_106: '分析报告',
  quantitative_research_107:
    '我们使用 SPSS® 和其他工具，通过不同方法构建分析报告',
  quantitative_research_108: '可以解决哪些业务挑战:',
  quantitative_research_109: '可以解决哪些业务挑战:',
  social_responsibility_1: '4Service 企业社会责任',
  social_responsibility_2:
    '源自我们团队每位成员的心灵和灵魂。我们努力在每位员工心中保持善意的火花，让周围的世界变得更美好',
  social_responsibility_3: '教育活动 / 青年支持',
  social_responsibility_4: '我们针对儿童和学生的宣传倡议',
  social_responsibility_5: 'Service Mania 商业游戏',
  social_responsibility_6:
    '我们培训活动的重要组成部分之一是 Service Mania 商业游戏。',
  social_responsibility_7:
    'Service Mania 挑战你从战略角度思考如何应对不寻常情况。',
  social_responsibility_8: '研究成果展示 / Diiya. Business',
  social_responsibility_9:
    '从企业和客户角度分析服务状况：4Service 乌克兰发展总监 Victoria Skorbota 展示我们的研究成果',
  social_responsibility_10: '服务设计研讨会',
  social_responsibility_11:
    '服务设计方法是 4Service 的重要组成部分。几年前，我们成为 DesignThinkers Academy 的合作伙伴，不仅在工作中应用最佳实践，还为顶级公司提供培训',
  social_responsibility_12: '慈善 / 志愿服务',
  social_responsibility_13:
    '孤儿院、养老院以及为乌克兰军队提供志愿服务——这些是我们最感人的活动',
  social_responsibility_14: '#HelpEasyWith4ServiceGroup',
  social_responsibility_15:
    '我们与 Blagomai 慈善基金合作，努力为那些急需帮助的人带去温暖和关爱',
  social_responsibility_16: '为孤儿院和养老院筹款',
  social_responsibility_17:
    '4Service 发起了多个为养老院和孤儿院筹集基本物资的募捐活动',
  social_responsibility_18: '#SaveUkraine',
  social_responsibility_19:
    '战争影响了我们的许多员工和亲友。我们每个人都在尽自己的一份力量',
  social_responsibility_20: '动物福利',
  social_responsibility_21:
    '任何人都可以带着宠物来到我们的办公室。我们帮助收容所，筹集粮食资金，并帮助流浪动物找到新家',
  social_responsibility_22: '支持动物收容所',
  social_responsibility_23: '流浪动物和社会中的弱势群体一样需要帮助。',
  social_responsibility_24:
    '我们公司已将 Sirius 流浪动物收容所（乌克兰基辅地区）纳入我们的关怀计划。',
  social_responsibility_25: '帮助流浪动物的创意倡议',
  social_responsibility_26: '如何让客户和合作伙伴关注动物收容所的紧迫问题？',
  social_responsibility_27: '宠物友好型办公室',
  social_responsibility_28:
    '我们的许多团队成员都有宠物。我们创建了一个健康的环境，让每个人都可以带着宠物来到办公室并感到舒适',
  ux_testing_1: 'UX 测试',
  ux_testing_1_1: 'UX 测试',
  ux_testing_2: '基于人工智能和人为分析的方法，测试并优化您的网站和应用',
  ux_testing_3: '什么是 UX 测试',
  ux_testing_4: 'UX 测试帮助您了解用户如何与您的产品、应用或网站交互',
  ux_testing_5: '导航不够清晰',
  ux_testing_6: '我不知道如何下订单',
  ux_testing_7: '产品目录中的图片不够多',
  ux_testing_8: '您将获得：',
  ux_testing_9: '发现改进机会',
  ux_testing_10: '识别设计问题和客户交互障碍',
  ux_testing_11: '找出用户在与网站交互时遇到的困难',
  ux_testing_12: '观察客户旅程',
  ux_testing_13: '识别您的目标受众何时以及为什么离开网站',
  ux_testing_14: '确定哪些部分引起最少和最多的兴趣与情感',
  ux_testing_15: '基于用户的 UX 测试',
  ux_testing_16:
    '4Service 提供真实的人类洞察，结合定性和定量方法，帮助您创建以客户为中心的网站和应用',
  ux_testing_17: '我不明白如何使用这个网站。菜单在哪里？',
  ux_testing_18: '我觉得字母之间的间距太大，文本难以阅读',
  ux_testing_19: '图片重叠在一起了，这正常吗？',
  ux_testing_20: 'UX 测试帮助您了解用户如何与您的产品、应用或网站交互',
  ux_testing_21: '基于用户的 UX 测试研究设计：',
  ux_testing_22: '发现改进机会',
  ux_testing_23: '确定测试类型和方法（定性/定量）',
  ux_testing_24: '制定假设和用户场景',
  ux_testing_25: '分析和报告测试结果',
  ux_testing_26: '两种解决方案',
  ux_testing_27: '我们提供两种 UX 测试方法',
  ux_testing_28: '基于用户的 UX 测试',
  ux_testing_29: '人工智能 + 人为分析 UX 测试',
  ux_testing_30: '我们的优势：',
  ux_testing_31: '我们可以分析竞争格局',
  ux_testing_32: '我们可以邀请专业专家进行和参与访谈',
  ux_testing_33: '我们可以用不同语言进行访谈并翻译成所需语言',
  ux_testing_34: '与现有的可用性',
  ux_testing_35: '指标或标准',
  ux_testing_36: '您的表现',
  ux_testing_37: '与竞争对手的',
  ux_testing_38: '版本',
  ux_testing_39: '相同产品的',
  ux_testing_40: '满意度评分',
  ux_testing_41: 'NPS',
  ux_testing_42: '成功率',
  ux_testing_43: '错误率',
  ux_testing_44: '任务完成时间',
  ux_testing_45: '基于用户的UX测试',
  ux_testing_46: '定量方法',
  ux_testing_47: '我们至少邀请100人参与此阶段的UX测试',
  ux_testing_48: '当您需要对比您的网站或应用时适用：',
  ux_testing_49: '定量方法衡量：',
  ux_testing_50: '观察',
  ux_testing_51: '与用户或用户群体共度时间，观察他们在日常生活中如何使用产品',
  ux_testing_52: '深度访谈',
  ux_testing_53:
    '帮助您了解访问网站用户的态度、信念、需求和经验。我们建议进行15-20次访谈',
  ux_testing_54: '民族志研究',
  ux_testing_55:
    '在受访者使用产品的环境中进行研究。通过观察，可以深入理解用户的心理及他们所面临的情感挑战。',
  ux_testing_56: '基于用户的UX测试',
  ux_testing_57: '定性方法',
  ux_testing_58: '该方法有助于理解用户行为的动机和逻辑',
  ux_testing_59: '我们使用：',
  ux_testing_60: '我们正在开发客户旅程地图，以直观展示研究结果',
  ux_testing_61: '30名参与者（男性/女性）',
  ux_testing_62: '对受访者进行预筛选，并邀请他们参与调查',
  ux_testing_63: '在Wantent平台上进行远程在线访谈',
  ux_testing_64: 'AI + 人工结合',
  ux_testing_65: 'AI + 人工结合的UX测试',
  ux_testing_66: '独特的人工智能技术Wantent与真实用户的结合',
  ux_testing_67: '标题的大字体吸引了注意力',
  ux_testing_68: '用户关注‘醒目的’数字，但不会阅读其旁边的信息',
  ux_testing_69: 'UX测试帮助您了解用户如何与您的产品、应用或网站互动',
  ux_testing_70: 'AI + 人工结合的测试研究设计',
  ux_testing_71: '运作方式',
  ux_testing_72: 'Wantent是一种基于AI的内容市场契合度解决方案。',
  ux_testing_73:
    'Wantent通过应用机器学习技术分析受众的情感反应和参与度，以评估网站和应用的效率。',
  ux_testing_74:
    '为了解释结果，我们使用讲故事的技巧、多样性和共情，以推动绩效和增长。',
  ux_testing_75: '用户在各个部分转换时的注意力和情绪',
  ux_testing_76: '按参与者群体统计数据（整个会话中的注意力和专注度）',
  ux_testing_77: '页面转化分析',
  ux_testing_78: '任务执行过程中的注意力和情绪',
  ux_testing_79: '对网站感知的研究结果',
  ux_testing_80: '不同参与者群体对网站的感知',
  ux_testing_81: '对页面导航的便利性',
  ux_testing_82: '以及查找重要元素的便利性分析',
  ux_testing_83: '对网站提供的信息的感知分析',
  ux_testing_84: '定义',
  ux_testing_85: '单个页面（导航、信息区块等）需要改进的领域',
  ux_testing_86: '我们详细分析',
  ux_testing_87: '研究的关键结果',
  ux_testing_88: '改善网站结构和单个页面的建议',
  ux_testing_89: '我们精心挑选目标受众进行可用性测试。',
  ux_testing_90: '我们在不同国家、不同语言和不同用户群体中进行研究',
  ux_testing_91: '我们在不同国家、不同语言和不同用户群体中进行研究',
  ux_testing_92: '我们可以在应用程序中进行测试',
  ux_testing_93: '以及在竞争对手的网站上进行测试，并提供对比分析',
  ux_testing_94: '我们结合不同的研究方法。',
  ux_testing_95: '我们的专业主持人引导参与者完成测试过程。',
  ux_testing_96: '我们进行测试',
  ux_testing_97: '在各种设备和软件版本上',
  ux_testing_98: '为什么选择我们？',
  wantent_1: '4Service x',
  wantent_2: 'Wantent',
  wantent_3:
    '4Service与Wantent的独特合作项目 © 结合人工智能与人为分析的方法进行内容分析',
  wantent_4: '在内容播出前评估成功率',
  wantent_5: '降低多样性问题的风险',
  wantent_6: '深入洞察与优化内容的建议',
  wantent_7: '关于内容和营销策略的客观决策',
  wantent_8: 'Wantent是一种基于AI的内容市场契合度解决方案。',
  wantent_9:
    'Wantent是一种基于人工智能的内容匹配市场解决方案。Wantent通过应用机器学习技术分析情感反应和受众参与度，以评估视频内容的有效性。',
  wantent_10: 'Wantent通过以下方式定义内容市场契合度并最大化内容效率',
  wantent_11: '场景设置与参与者招募',
  wantent_12: '个性化项目设计及全球受众覆盖',
  wantent_13: '收集观众反应',
  wantent_14: '来自受众的详细和清晰反馈',
  wantent_15: '内容感知分析',
  wantent_16: '由AI进行的行为和情感反应分析',
  wantent_17: '提供最终总结的洞察',
  wantent_18: '优化建议',
  wantent_19: 'Wantent最大化您的内容效率',
  wantent_20: '广告概念前测',
  wantent_21: '创意概念测试',
  wantent_22:
    '验证未来创意与既定策略的一致性，并了解目标受众的反应，以便调整创意概念/信息',
  wantent_23: '品牌元素可视性测试（后期制作）',
  wantent_24: '确认广告/赞助投资的有效性',
  wantent_25: '广告测试',
  wantent_26: 'A/B测试',
  wantent_27: '对比创意的有效性，并在制作阶段提高参与度和注意力',
  wantent_28: '已发布广告测试',
  wantent_29: '定义信息传达效果，并提供优化音频和视觉效果的建议',
  wantent_30: '电视解决方案',
  wantent_31: '试播节目、宣传片、新节目形式、电视主持人测试',
  wantent_32: '进行对比分析，以确定最具吸引力的内容并加以强化',
  wantent_33: '电视节目和故事片测试',
  wantent_34:
    '分析观众的参与度、注意力水平和观看长视频内容时的情感反应。我们会自动检测观众流失高峰和注意力分散时刻，以评估并优化视频剪辑',
  wantent_35: 'UI/UX测试',
  wantent_36: '网站原型和移动应用测试',
  wantent_37: '使用Wantent技术分析用户反应和情感：',
  wantent_38: '注意力水平',
  wantent_39: '情感反应',
  wantent_40: '参与者视线方向的热图',
  wantent_41: '基于参与者反馈的网页和应用可用性分析：',
  wantent_42: '系统可用性量表（SUS）',
  wantent_43: '客户努力评分（互动便捷性）',
  wantent_44: 'Net Promotion Score (NPS)',
  wantent_45: 'GDPR合规性与用户隐私',
  wantent_46:
    'Wantent完全符合GDPR和CCPA政策，并遵循参与者个人数据的收集、存储、处理和保护原则',
  wantent_47: 'Nikita Lobyntsev',
  wantent_48: 'СDO, Reface（媒体与娱乐）',
  wantent_49:
    '我们每天都在使用机器学习技术尝试大量新的内容创意。Wantent帮助我们理解和评估风险与优势，发现用户的反馈、行为和感知，从而分析我们解决方案中不同方面的因果关系。',
  wantent_50: 'Alexander Smirnov',
  wantent_51: 'TABASCO（广告）联合所有者',
  wantent_52:
    'Wantent提供了一项真正独特的服务，使我们能够了解消费者喜欢和不喜欢的每一个细节。无法作弊，也无法撒谎——Wantent总是知道真相，因此我们作为市场营销专家可以获得无价的（哈哈哈——其实我们知道确切的价格，而且它是可负担的）指南，以优化我们的沟通策略。',
  wantent_53: '评论',
  terms_1: '条款与条件',
  terms_2: '使用条款协议',
  terms_3: '在使用本网站之前，请仔细阅读这些使用条款协议（“使用条款”，“协议”）',
  terms_4:
    '（“网站”）由4Service Holdings GmbH（“4Service”，“我们”，“我们”，“我们的”）运营。',
  terms_5:
    '使用条件：使用本网站即表示您已阅读并理解本协议，并同意遵守其条款。如果您不愿受本协议约束，请立即离开本网站。4Service仅向接受本协议条款的用户提供本网站、产品和服务的使用权限。',
  terms_6: '隐私政策',
  terms_7:
    '在继续使用我们的网站之前，我们建议您阅读我们的隐私政策，了解我们的用户数据收集方式。这将帮助您更好地理解我们的操作方式。',
  terms_8: '年龄限制',
  terms_9:
    '您必须年满16（十六）岁才能使用本网站。使用本网站即表示您保证自己至少已年满16（十六）岁，并且有法律资格遵守本协议。4Service不对因年龄虚报产生的任何责任承担责任。',
  terms_10: '知识产权',
  terms_11:
    '您同意本网站上的所有材料、产品和服务均属于4Service及其附属机构、董事、高管、员工、代理、供应商或许可方的财产，包括所有版权、商业机密、商标、专利及其他知识产权。您还同意不会以任何方式（包括电子、数字或新的商标注册）复制或再分发4Service的知识产权。',
  terms_12: '访问我们的网站',
  terms_13:
    '我们的网站访问权限是临时性的，我们保留随时撤销或更改网站服务的权利，恕不另行通知。如果本网站在任何时间或任何时段无法访问，我们不承担任何责任。我们可能会不时限制部分或全部注册用户的访问权限。您需自行负责确保访问我们网站所需的所有安排，包括使用兼容的网站设备。您还需确保通过您的网络连接访问我们网站的所有用户知悉这些条款，并遵守它们。',
  terms_14: '适用法律',
  terms_15:
    '访问本网站即表示您同意本协议受奥地利共和国法律管辖，不考虑法律冲突原则。',
  terms_16: '争议解决',
  terms_17: '任何与您访问本网站相关的争议均应提交维也纳商事法院仲裁。',
  terms_18: '赔偿责任',
  terms_19:
    '您同意赔偿4Service及其附属公司，并确保4Service免受因您使用或误用本网站而可能引发的法律索赔和诉讼。我们保留自行选择法律顾问的权利。',
  terms_20: '存储期限',
  terms_21:
    '考虑到处理目的，用户个人数据的存储期限（存储期）为自您正式提供数据处理同意之日起24个月。',
  terms_22: '责任限制',
  terms_23:
    '4Service不对因您误用本网站可能导致的任何损害承担责任。4Service保留随时更改、修改和更新本协议的权利，恕不另行通知。您继续使用本网站，即表示您接受这些更改或修改。如果本协议的任何部分被认定为非法、无效或不可执行，该部分将被视为可分割部分，不影响其余条款的有效性和可执行性。如发现本网站有任何非法使用的证据，我们将向执法机构提供相关信息。本协议是4Service与用户之间的协议。',
  terms_24: '请将所有与隐私/使用相关的问题和疑虑发送至以下地址：',
  terms_25: '4Service Holdings GmbH',
  terms_26: 'Tegetthoffstrasse 7',
  terms_27: '1010 维也纳',
  terms_28: '奥地利',
  terms_29: '审核',
  terms_30:
    '如果您提供给我们的个人数据不准确，您有权要求我们对其进行更正（GDPR第16条）。',
  thank_you_1: '谢谢！',
  thank_you_2: '我们将在24小时内回复您',
  thank_you_3: 'P.S. 我们的经理正在审核您的请求，以提供更优的方案',
  thank_you_4: '菜单',
  thank_you_5: '女性打字',
  privacy_policy_1: '数据主体（网站用户）隐私声明表',
  privacy_policy_2:
    '本隐私声明（隐私声明）适用于4Service Holdings GmbH在网站访问过程中收集个人数据的自然人（数据主体），符合GDPR的要求',
  privacy_policy_3: '（以下简称“网站”及“网站用户”/“用户”）。',
  privacy_policy_4:
    '4Service Holdings GmbH的数据主体隐私声明适用于所有受其法律监管或控制的4Service集团公司。',
  privacy_policy_5: '联系方式',
  privacy_policy_6: '4Service Holdings GmbH',
  privacy_policy_7: '(公司/我们/我们自己)',
  privacy_policy_8: '地址:',
  privacy_policy_9: 'Tegetthoffstraße 7, 1010 维也纳, 奥地利。',
  privacy_policy_10: '电子邮件:',
  privacy_policy_12: '我们是谁？',
  privacy_policy_13:
    '访问本网站的个人（您），无论出于何种目的。在本文件中，您也将被称为用户。',
  privacy_policy_14: '我们从您那里收集的个人数据',
  privacy_policy_15:
    '当您访问我们的网站时，我们会向您发送隐私通知，其中我们请求您同意处理以下信息:',
  privacy_policy_16:
    'IP地址、用户名、姓氏、地址、电话号码（座机或手机）、电子邮件地址、公司名称、国家、电子邮件地址、名字、姓氏、电话号码、省份、州和邮政编码、使用数据、与外部社交网络或平台的交互数据、关于网站注册和认证的信息',
  privacy_policy_17: '地理位置。',
  privacy_policy_18:
    '如果您表示同意并给予我们授权，我们将开始处理您的相关信息。',
  privacy_policy_19: '合法性（同意）',
  privacy_policy_20:
    '当您访问我们的网站时，我们会向您发送隐私通知，其中我们请求您同意处理以下信息:',
  privacy_policy_21:
    '处理个人数据的法律依据是同意，我们将在以下链接的同意表单中获取您的授权:',
  privacy_policy_22:
    '如果您填写同意表单，则表示您理解并接受本隐私通知中规定的所有条件。',
  privacy_policy_23: '撤回同意',
  privacy_policy_24:
    '您有权随时撤回您之前提供的同意。撤回同意不会影响撤回前基于同意进行的处理的合法性。您可以通过向以下电子邮件地址发送请求来撤回您的同意：withdraw@4service-group.com，并且，您可以在以下链接找到请求表单:',
  privacy_policy_25: '用户撤回同意表单',
  privacy_policy_26: '处理目的',
  privacy_policy_27: '我们处理您的个人数据的目的如下:',
  privacy_policy_28:
    '– 改善客户服务（更有效地响应客户请求）；– 个性化用户体验（确定谁对服务更感兴趣）；– 改善网站（提高产品和服务的质量，提高使用的便利性，开发新服务，增强我们的产品和服务）；– 通过新闻通讯、营销或促销材料以及包括我们的新闻、更新、服务信息的其他信息与用户沟通，同时提供拒收后续电子邮件的说明；– 基于匿名数据进行统计和其他类型的研究和分析；– 为用户提供个性化服务并履行协议和合同；– 允许用户通过网站参与我们实施的各种项目，回应用户通过网站提出的查询，进行研究，维护账户和记录，并推广服务。',
  privacy_policy_29: '个人数据可能被传输的对象',
  privacy_policy_30:
    '在处理您的个人数据时，我们将其传输给作为公司数据处理者的实体。公司的数据处理者仅根据公司的指示行事。数据处理者执行的具体操作以及数据处理者的列表可在以下链接的《隐私和数据保护政策》中找到: Privacy and Data Protection Policy',
  privacy_policy_31: '个人数据可能被传输的国家',
  privacy_policy_32:
    '公司根据《通用数据保护条例》（GDPR）和欧盟委员会的规定，在充分性决定的基础上传输您的个人数据。关于将个人数据传输到美国的更多信息，请参见以下链接的《隐私和数据保护政策》: Privacy and Data Protection Policy。',
  privacy_policy_33: '存储期限',
  privacy_policy_34:
    '考虑到处理目的，用户个人数据的存储期限为自您正式提供数据处理同意之日起24个月。',
  privacy_policy_35: '访问权',
  privacy_policy_36:
    '您有权知道是否正在处理您的个人数据，并且如果是，则可以根据GDPR第15条规定访问这些数据。',
  privacy_policy_37: '更正权',
  privacy_policy_38:
    '如果您提供的个人数据不准确，您有权要求我们进行更正（GDPR第16条）。',
  privacy_policy_39: '删除权（被遗忘权）',
  privacy_policy_40:
    '您有权在不延迟的情况下要求我们删除您的个人数据，并且在GDPR第17条规定的情况下，我们有义务立即删除您的个人数据。',
  privacy_policy_41: '限制处理权',
  privacy_policy_42:
    '在GDPR的适用范围内，特别是第18条的规定下，您有权限制您的个人数据处理。',
  privacy_policy_43:
    '我们有义务告知您所收集的数据、使用方式、存储时间以及是否会与第三方共享。这些信息必须以简明易懂的语言进行沟通。',
  privacy_policy_44: '数据可携带权',
  privacy_policy_45:
    '您有权获取并重新使用您的个人数据，以在不同服务之间进行个人用途。',
  privacy_policy_46: '反对权',
  privacy_policy_47:
    '您有权反对公司处理您的个人数据。除非我们证明处理有凌驾于个人利益、权利和自由的合法理由，或者处理是为了建立、行使或辩护法律主张，否则我们必须停止处理个人数据。',
  privacy_policy_48: '不受仅基于自动化处理的决定约束的权利',
  privacy_policy_49:
    '您有权反对在未经同意的情况下进行的任何自动分析。此外，您有权要求您的个人数据必须由人工介入进行处理。',
  privacy_policy_50: '投诉',
  privacy_policy_51:
    '如果您希望就公司（或上述数据处理者）处理您的个人数据的方式或处理您的投诉的方式提出投诉，您有权直接向监管机构和公司提出投诉。',
  privacy_policy_52: '这些联系人的详细信息如下:',
  privacy_policy_53: '监管机构:',
  privacy_policy_54: '奥地利数据保护局',
  privacy_policy_55: 'Österreichische Datenschutzbehörde',
  privacy_policy_56: 'Wickenburggasse 8',
  privacy_policy_57: '1080 维也纳',
  privacy_policy_58: '奥地利 / 欧洲',
  privacy_policy_59: '公司:',
  privacy_policy_60: '4Service Holdings GmbH（公司/我们/我们自己）',
  privacy_policy_61: '地址: Tegetthoffstraße 7, 1010 维也纳, 奥地利。',
  privacy_policy_62: '电子邮件:',
  privacy_policy_63: '隐私和数据保护政策',
  privacy_policy_64:
    '在此阅读更多关于我们如何以及为什么使用您的数据: Privacy and Data Protection Policy',
  privacy_policy_65: '批准',
  privacy_policy_66:
    '公司已制定所有内部文件，以明确公司内部个人数据处理的角色，特别是负责批准和审查本文件合法性的是董事总经理。',
  contacts_1: '客户联系信息',
  contacts_2: '适用于所有类型的企业、市场研究机构、大型公司、商业伙伴和媒体。',
  contacts_3: 'Tegetthoffstrasse 7, 维也纳, 奥地利',
  contacts_4: '适用于购物者',
  contacts_5: '本地人和游客、司机和学生、专业神秘购物者和宅家族。',
  contacts_6: '从您的国家联系我们:',
  contacts_7: '意大利',
  contacts_8: '美国',
  contacts_9: '英国',
  contacts_10: '瑞士',
  contacts_11: '荷兰',
  contacts_12: '斯洛伐克',
  contacts_13: '斯洛文尼亚',
  contacts_14: '罗马尼亚',
  contacts_15: '阿塞拜疆',
  contacts_16: '乌克兰',
  contacts_17: '哈萨克斯坦',
  contacts_18: '其他地区',
  menu_1: 'CJM',
  menu_2: 'NPS',
  menu_3: 'CSI',
  menu_4: 'BHT',
  menu_5: 'UX 测试',
  menu_6: 'HR 研究',
  menu_7: '定性研究',
  menu_8: '定量研究',
  menu_9: '神秘购物',
  menu_10: 'Voicer',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: '价格监控',
  menu_14: '关于我们',
  menu_15: '联系我们',
  menu_16: '博客',
  menu_17: '方法',
  menu_18: '产品',
  menu_19: '购物者 \n平台',
  menu_20: 'CSR',
  menu_21: '汽车价格分析',
  menu_22: '设施检查审计',
  menu_23: '服务设计',
  menu_24: 'CX',
  nps_passives: '被动',
  nps_detractors: '批评者',
  nps_promoters: '促进者',
  nps_a_score: 'A 分数',
  area: '地区',
  products_tabs_1: '为了实现最大效率，我们也在复杂中进行以下操作：',
  products_tabs_2: '产品',
  products_tabs_3: '定性研究是收集和分析非数值数据，以理解概念、意见或经验。',
  products_tabs_4:
    '定量研究方法是通过民意调查、问卷和调查收集数据的客观测量和数值分析。',
  our_clients_1: '我们的客户',
  preview_cases_section_1: '案例',
  preview_cases_section_2: '访问案例阅读更多有趣的帖子',
  blog_1: '激动人心的内容博客',
  blog_2: '您的请求没有可用的帖子',
  about: '关于',
  why_us: '为什么选择我们',
  about_us: '关于我们',
  key_features: '关键特点',
  solutions: '解决方案',
  monitoring: '监控',
  how: '如何',
  how_it_works: '它是如何工作的',
  when_to_use: '何时使用',
  mystery_shopping: '神秘购物',
  voicer: '顾客之声',
  wantent: '视频内容测试',
  play4sales: 'Play4Sales',
  price_monitoring: '价格监控',
  service_design: '服务设计',
  qualitative_research: '定性研究',
  quantitative_research: '定量研究',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '#汽车',
  hashtag_retayl: '#零售',
  hashtag_all_posts: '#所有帖子',
  hashtag_feedback: '#反馈',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#案例',
  hashtag_market_research: '#市场研究',
  more: '更多',
  speak_to_an_expert: '与专家交谈',
  book_consultancy: '预约咨询',
  read_all: '阅读全部',
  find_out_more: '了解更多',
  address: '地址',
  mon_fri: '周一至周五',
  phone_number: '电话号码',
  flag: '旗帜',
  scroll_to_left: '向左滚动',
  online: '在线',
  tel: '电话',
  email: '电子邮件',
  light_it_up: '点亮它',
  about_us_60: 'Alina Andreieva',
  about_us_61: '业务发展总监',
  about_us_62: 'Julia Kravchenko',
  about_us_63: '高级项目经理',
  about_us_64: 'Olga Aksonova',
  about_us_65: '业务发展经理',
  about_us_66: 'Zhelevskiy Dmitriy',
  about_us_67: '运营总监',
  about_us_roles_1: '管理层',
  about_us_roles_2: '全球团队',
  about_us_roles_3: '产品负责人',
  ad_testing_1: '广告测试',
  ad_testing_2: '广告活动是巨大的投资。确保您的广告有力并带来最大的投资回报',
  ad_testing_3: '锁定',
  ad_testing_4: '我们服务的行业',
  ad_testing_5: '4Service是一个全球客户体验研究集团',
  ad_testing_6:
    '4Service是全球市场研究和CX集团。我们为各种规模的企业提供专业数据收集服务',
  ad_testing_7: '现金与自取',
  ad_testing_8: '零售',
  ad_testing_9: '电子产品',
  ad_testing_10: '奢侈/高端',
  ad_testing_11: '餐饮与酒店业',
  ad_testing_12: '汽车',
  ad_testing_13: '旅游与休闲',
  ad_testing_14: '时尚',
  ad_testing_15: '银行',
  ad_testing_16: '手表与珠宝',
  ad_testing_17: '家电与电器',
  ad_testing_18: 'Esomar 会员',
  ad_testing_19: '我们已为不同领域的各种企业进行过广告测试研究',
  ad_testing_20: '如果您在以下情况中，您需要广告测试',
  ad_testing_21: '推广新产品或服务',
  ad_testing_22: '涉及敏感话题',
  ad_testing_23: '尝试接触新的目标群体或市场',
  ad_testing_24: '讨论几种不同的设计选项',
  ad_testing_25: '需要向管理团队或投资者提供概念验证',
  ad_testing_26: '您将获得以下问题的答案',
  ad_testing_27: '哪些广告渠道最适合这些广告？',
  ad_testing_28: '我们是否使用了正确的视觉效果来传达信息？',
  ad_testing_29: '您的广告文案和信息是否引起共鸣？',
  ad_testing_30: '哪些广告渠道最适合这些广告？',
  ad_testing_31: '是什么首先吸引了他们的注意？',
  ad_testing_32: '广告的布局和排版是否易于理解？',
  ad_testing_33: '我们评估',
  ad_testing_34: '品牌塑造',
  ad_testing_35: '您的品牌与广告的关联，以及它将被记住的程度',
  ad_testing_36: '关键指标',
  ad_testing_37: '整合',
  ad_testing_38: '识别',
  ad_testing_39: '契合度',
  ad_testing_40: '创意',
  ad_testing_41: '您的广告如何脱颖而出并吸引人们的注意',
  ad_testing_42: '关键指标',
  ad_testing_43: '识别度',
  ad_testing_44: '喜好度',
  ad_testing_45: 'MTO',
  ad_testing_46: '动机',
  ad_testing_47: '客户体验，情感参与',
  ad_testing_48:
    '通过使用人工智能技术和专家分析师，我们分析人们的真实情感，并获取他们对广告的认知洞察',
  ad_testing_49: '评分',
  ad_testing_50: '男性',
  ad_testing_51: '女性',
  ad_testing_52: '高度参与',
  ad_testing_53: '注意力',
  ad_testing_54: '观众喜欢并记住了什么？',
  ad_testing_55: '女演员',
  ad_testing_56: '平等',
  ad_testing_57: '音乐背景',
  ad_testing_58: '积极情绪',
  ad_testing_59: '不同种族和外貌的人',
  ad_testing_60: '户外镜头',
  ad_testing_61: '观众不喜欢并记住了什么？',
  ad_testing_62: '讲者的声音与屏幕上的内容不匹配',
  ad_testing_63: '对产品的关注度低',
  ad_testing_64: '过于动态',
  ad_testing_65: '难以理解',
  ad_testing_66: 'TRP',
  ad_testing_67: '印象',
  ad_testing_68: '展示',
  ad_testing_69: '转化',
  ad_testing_70: '媒体',
  ad_testing_71:
    '我们结合媒体活动衡量广告活动的有效性，计算不同渠道的媒体投资对监测结果的影响。',
  ad_testing_72: '我们在任何格式、平台或渠道上进行广告研究',
  ad_testing_73: '视频内容',
  ad_testing_74: '户外',
  ad_testing_75: '电视广告',
  ad_testing_76: '印刷',
  ad_testing_77: '数字',
  ad_testing_78: '广告活动',
  ad_testing_79: 'POS展示和广告',
  ad_testing_80: '动画片段',
  ad_testing_81: '在我们的帮助下，您可以在任何阶段测试您的广告',
  ad_testing_82: '概念',
  ad_testing_83: '哪些创意具有更强的能力？',
  ad_testing_84: '早期生产阶段',
  ad_testing_85: '哪些动画片段将进入制作？',
  ad_testing_86: '制作',
  ad_testing_87: '如何编辑视频，以便能够保持观众的注意力？',
  ad_testing_88: '前媒体',
  ad_testing_89: '哪些传播渠道有效，预期结果是什么？',
  ad_testing_90: '广告后期测试',
  ad_testing_91: '制作',
  ad_testing_92: '我的广告有吸引力吗？创意的效果是否随着时间的推移而减弱？',
  ad_testing_93: '前媒体',
  ad_testing_94: '我的广告效果如何？它与竞争对手相比如何？',
  ad_testing_95: '广告前期测试',
  ad_testing_96: '为了提供高质量的数据，我们使用',
  ad_testing_97: '定量研究方法',
  ad_testing_98: 'CAWI',
  ad_testing_99: '定性研究方法',
  ad_testing_100: '焦点小组',
  ad_testing_101: '人工智能',
  ad_testing_102: 'Wantent',
  ad_testing_103: '您将收到的分析报告',
  ad_testing_104:
    '我们的分析师、媒体专家和市场营销人员团队将准备并呈现您定制的报告，并提供详细建议',
  ad_testing_age: '年龄',
  ad_testing_ad: '广告',
  automotive_industry_price_analysis_1: '汽车行业价格分析',
  automotive_industry_price_analysis_2:
    '竞争价格分析可以帮助防止利润流失，增加市场份额，并监控您的市场定位。让我们帮助您选择成功的竞争策略！',
  automotive_industry_price_analysis_3: '请求报价',
  automotive_industry_price_analysis_4: '我们的方法论',
  automotive_industry_price_analysis_5: '时尚优雅的汽车沙龙',
  automotive_industry_price_analysis_6:
    '神秘购物法是唯一一种能准确反映真实客户体验并提供可靠概述的方法。',
  automotive_industry_price_analysis_7: '我们提供准确的数字和可靠的多方面数据',
  automotive_industry_price_analysis_8: '我们提供全球覆盖，涵盖全球每个国家',
  automotive_industry_price_analysis_9: '我们的内部资源包括神秘购物者和审计员',
  automotive_industry_price_analysis_10: '我们验证我们数据的质量',
  automotive_industry_price_analysis_11: '我们的优势：',
  automotive_industry_price_analysis_12: '特定竞争型号的价格监控（B2B和B2C）',
  automotive_industry_price_analysis_13: '折扣水平监控',
  automotive_industry_price_analysis_14: '监控零售商的品牌和竞争对手的库存',
  automotive_industry_price_analysis_15: '监控电子商务汽车价格',
  automotive_industry_price_analysis_16: '价格传播分析',
  automotive_industry_price_analysis_17: '跟踪零售商的运输费用',
  automotive_industry_price_analysis_18: '监控零售商的促销和销售',
  automotive_industry_price_analysis_19: '确定月付款金额',
  automotive_industry_price_analysis_20: '计算租赁付款',
  automotive_industry_price_analysis_21: '分析电动汽车（EV）的特定定价因素',
  automotive_industry_price_analysis_22: '进行直销与零售商价格比较',
  automotive_industry_price_analysis_23: '开发订阅定价模型',
  automotive_industry_price_analysis_24:
    '4Service是一家全球客户体验（CX）控股公司，拥有超过20年的经验',
  automotive_industry_price_analysis_25:
    '您将使用关于消费者愿意为不同特性支付的数据显示优化您的产品，并识别您的目标客户最重要的特性。',
  automotive_industry_price_analysis_26: '4Service对汽车行业价格的分析包括：',
  automotive_industry_price_analysis_27:
    '最低价格并不总是汽车品牌竞争力的关键。让我们帮助您制定长期定价策略',
  automotive_industry_price_analysis_28: '的客户理解价格在所有品牌中普遍上涨',
  automotive_industry_price_analysis_29: '29',
  automotive_industry_price_analysis_30:
    '的客户表示，如果品牌告知他们价格将上涨，他们仍会购买喜欢的汽车',
  automotive_industry_price_analysis_31: '31',
  automotive_industry_price_analysis_32:
    '的人认为租赁和月付款是他们购买汽车的首选方式',
  automotive_industry_price_analysis_33: '48',
  automotive_industry_price_analysis_34:
    '的经销商提到在沟通/销售过程中可能会出现价格上涨',
  automotive_industry_price_analysis_35: '47.6',
  automotive_industry_price_analysis_36: '关键数字',
  automotive_industry_price_analysis_37: '您将弄清楚如何相对于其他车辆定价。',
  automotive_industry_price_analysis_38:
    '您将使用关于消费者愿意为不同特性支付的数据显示优化您的产品，并识别您的目标客户最重要的特性。',
  automotive_industry_price_analysis_39:
    '的客户表示，如果品牌告知他们价格将上涨，他们仍会购买喜欢的汽车',
  automotive_industry_price_analysis_40: '您将能够确定适当的月付款和租赁利率。',
  automotive_industry_price_analysis_41: '对您的品牌或经销商有哪些好处：',
  automotive_industry_price_analysis_42: '您提交申请',
  automotive_industry_price_analysis_43: '我们的经理联系您以确定主要目标',
  automotive_industry_price_analysis_44: '我们进行市场研究',
  automotive_industry_price_analysis_45: '我们定期以在线格式向您提供报告和建议',
  automotive_industry_price_analysis_46: '带销售标签的汽车',
  automotive_industry_price_analysis_47: '我们在1天内启动项目！',
  automotive_industry_price_analysis_48:
    '我们提供一整套报告，包括照片报告、PPT报告和Excel报告，按地区类型划分',
  retail_audit_1: '现场营销审计/零售审计',
  retail_audit_2:
    '收集关于您的商店或品牌的详细数据，分析增长障碍，并制定有效的战略来克服这些障碍',
  retail_audit_3: '请求报价',
  retail_audit_4:
    '4Service代表品牌进行现场门店审核，评估其促销策略、现场执行团队和市场营销战术在达到目标市场方面的有效性。',
  retail_audit_5: '我们仔细观察促销活动的执行，并确保遵守促销指南。',
  retail_audit_6: '前10名',
  retail_audit_7: '欧洲CX机构',
  retail_audit_8: '年经验',
  retail_audit_9: '覆盖国家',
  retail_audit_10: '160万',
  retail_audit_11: '每年评估次数',
  retail_audit_12: '我们跟踪什么？',
  retail_audit_13: '销售点（POS）材料的存在',
  retail_audit_14: '品牌大使的存在和激活，确保遵守计划的时间表',
  retail_audit_15: '评估品牌大使在倡导活动中的参与',
  retail_audit_16: '评估消费者互动，确保遵守促销指南和品牌信息',
  retail_audit_17: '防止欺诈措施',
  retail_audit_18: '您的企业可以使用现场营销审核的结果来：',
  retail_audit_19: '评估与预算和流程的合规性',
  retail_audit_20: '将实际结果与预期目标进行比较',
  retail_audit_21: '提升营销活动的表现',
  retail_audit_22: '为未来制定战略计划',
  retail_audit_23: '识别减少成本的机会',
  retail_audit_24: '提高销售和转化率',
  retail_audit_25: '优化投资回报率（ROI）',
  retail_audit_26: '他们选择4SERVICE作为他们的贸易投资合作伙伴',
  retail_audit_27:
    '一家领先的国际烟草产品制造商与4Service合作，提升其品牌并改善其店内表现。我们的团队提供现场营销审核和消费者体验实时报告。',
  retail_audit_28: '提升现场营销代理机构的计划准确性',
  retail_audit_29: '提升品牌信息传达',
  retail_audit_30: '提升品牌大使参与度（消费者激活）',
  retail_audit_31: '提升数据收集准确性和GDPR合规性',
  retail_audit_32: '我们倾向于发现哪些有价值的见解：',
  retail_audit_33:
    'SLA条款之间缺乏一致性甚至冲突，导致对客户产生未经批准的费用',
  retail_audit_34: '由于混淆提供的服务类型，错误地收取费用',
  retail_audit_35: '未执行现场服务，包括未将员工分配到计划的地点|POS',
  retail_audit_36: '按估算收费而非实际收费，且未进行对账',
  retail_audit_37: '错误应用促销指南，提供虚假的数据',
  retail_audit_38: '我们是如何工作的？',
  retail_audit_39:
    '我们的审核员根据代理机构的激活计划访问指定的销售点（POS）位置。',
  retail_audit_40:
    '他们评估简报中概述的关键绩效指标（KPI），如POS存在、品牌大使参与、遵守促销指南和防止欺诈措施。',
  retail_audit_41: '验证：',
  retail_audit_42: '我们收集并整合所获得的数据。',
  retail_audit_43: '撰写一份全面的报告。',
  retail_audit_44:
    '我们的验证团队彻底审查所有调查，确保准确性，包括与项目简报的一致性以及任何附加评论。',
  retail_audit_45: '在线报告系统：',
  retail_audit_46: '已完成并验证的问卷将在36小时内上传到我们的在线平台。',
  retail_audit_47: '客户可以访问个人帐户门户，随时监控进度。',
  retail_audit_48: '提供包含结果和建议的最终报告。',
  retail_audit_49: '与专家交谈',
  retail_audit_50: '我们的优势：',
  facility_check_audit_1: '设施',
  facility_check_audit_2: '检查审核',
  facility_check_audit_3: '提升每个细节中的品牌体验',
  facility_check_audit_4: '探索我们的方式',
  facility_check_audit_5: '关于',
  facility_check_audit_6: '我们是谁',
  facility_check_audit_7:
    '作为一家全球客户体验控股公司，4Service提供全面的服务套件，帮助品牌为其客户创造并提供卓越的体验。',
  facility_check_audit_8: '我们的设施检查审核服务',
  facility_check_audit_9:
    '旨在帮助您确保您的实体店铺和品牌在零售店的存在符合品牌标准，并为客户创造积极的印象。',
  facility_check_audit_10: '解决方案1',
  facility_check_audit_11: '设施检查审核',
  facility_check_audit_12:
    '是一项细致的检查，评估您的零售店或展位是否与您的品牌标准对齐。我们不仅验证物理属性，还评估这些元素如何影响您的品牌在客户中的感知。',
  facility_check_audit_13: '两种解决方案',
  facility_check_audit_14: '两种实施方法',
  facility_check_audit_15: '方法',
  facility_check_audit_16: '专家审核员的设施检查审核',
  facility_check_audit_17: '设施检查验证',
  facility_check_audit_18: '报告',
  facility_check_audit_19:
    '您将在48小时内收到报告，报告中包括视觉证据和统计数据。',
  facility_check_audit_20:
    '一项执行良好的设施检查审核可以为您的品牌带来许多好处，包括：',
  facility_check_audit_21: '提升客户转化率：',
  facility_check_audit_22:
    '积极的客户体验可以带来更多的销售和回头客。我们的审核可以帮助您识别并解决可能影响客户满意度的任何问题。',
  facility_check_audit_23: '提升品牌形象：',
  facility_check_audit_24:
    '您的实体店是客户的关键接触点，它们在塑造您的品牌形象方面起着重要作用。我们的审核可以帮助您确保您的店铺与品牌价值一致，并为客户创造积极的印象。',
  facility_check_audit_25: '为什么选择我们？',
  facility_check_audit_26: '为什么设施检查审核很重要？',
  facility_check_audit_27:
    '一项执行良好的设施检查审核可以为您的品牌带来许多好处，包括：',
  facility_check_audit_28: '提升品牌形象：',
  facility_check_audit_29:
    '您的实体店是客户的关键接触点，它们在塑造您的品牌形象方面起着重要作用。我们的审核可以帮助您确保您的店铺与品牌价值一致，并为客户创造积极的印象。',
  facility_check_audit_30: '提升客户转化率：',
  facility_check_audit_31:
    '积极的客户体验可以带来更多的销售和回头客。我们的审核可以帮助您识别并解决可能影响客户满意度的任何问题。',
  facility_check_audit_32: '谁需要',
  facility_check_audit_33: '谁需要设施检查审核？',
  facility_check_audit_34:
    '设施检查审核是任何拥有实体位置和物理存在的品牌的宝贵服务。对于希望：',
  facility_check_audit_35: '确保符合品牌标准的品牌尤其重要：',
  facility_check_audit_36: '我们的审核可以帮助您识别您的位置是否偏离品牌标准。',
  facility_check_audit_37: '提升客户体验：',
  facility_check_audit_38: '我们的审核可以帮助您识别提升客户体验的机会。',
  facility_check_audit_39: '建立更强大的品牌：',
  facility_check_audit_40:
    '我们的审计可以帮助您确保您的实体位置为客户创造积极的印象。',
  facility_check_audit_41: '您的员工或神秘购物者拍摄该地点的照片。',
  facility_check_audit_42: '然后，他们填写问卷并附上照片。',
  facility_check_audit_43: '验证者收到照片，并检查其是否符合标准。',
  facility_check_audit_44: '专家审计员的设施检查审计',
  facility_check_audit_45: '准备阶段：',
  facility_check_audit_46: '协作批准审计时间表',
  facility_check_audit_47: '经销商已准备好并告知即将进行的审计',
  facility_check_audit_48: '审计员培训：',
  facility_check_audit_49: '我们经验丰富的4Service培训师为审计员提供品牌指南',
  facility_check_audit_50: '设施审计阶段：',
  facility_check_audit_51: '审计员持有特殊授权信访问地点',
  facility_check_audit_52: '对每个点进行彻底检查，严格遵循指南',
  facility_check_audit_53: '进行视觉文档记录，并与总部要求进行评估',
  facility_check_audit_54: '结论性PPT报告',
  facility_check_audit_55: '一份全面的PowerPoint报告，阐明发现',
  facility_check_audit_56: '沉浸式的在线/离线审计结果展示',
  facility_check_audit_57: '设施检查验证',
  facility_check_audit_58: '步骤：',
  facility_check_audit_59: '设施审计阶段：',
  facility_check_audit_60: '品牌代表使用4Service应用程序拍摄现场照片',
  facility_check_audit_61: '遵守严格的视觉和描述标准',
  facility_check_audit_62: '验证阶段：',
  facility_check_audit_63: '勤勉的验证者仔细审查每个报告',
  facility_check_audit_64: '将照片与品牌标准进行全面比较',
  facility_check_audit_65: '注释和见解整合到报告中，以便更清晰',
  facility_check_audit_66: '如有需要，直接与经销商沟通进行澄清',
  facility_check_audit_67: '报告阶段：',
  facility_check_audit_68: '报告，包括视觉证据和统计数据，通常在两天内提供',
  facility_check_audit_69: '今天联系我们',
  cx_solution_1: '我们不仅仅是发现洞察，',
  cx_solution_2: '我们将您的业务提升到新高度',
  cx_solution_3:
    '拥有超过20年客户经验的专家发现复杂的解决方案，并为您提供具体的行动计划，促进您的增长',
  cx_solution_4: '发现一个独特的服务套件，集成在一个未来-proof的解决方案中',
  cx_solution_5: '一体化CX解决方案',
  cx_solution_6: '广告测试',
  cx_solution_7: '人工智能和神经市场营销',
  cx_solution_8: '客户之声',
  cx_solution_9: '桌面研究',
  cx_solution_10: 'CJM',
  cx_solution_11: '神秘购物',
  cx_solution_12: 'CX咨询',
  cx_solution_13: '社交媒体聆听',
  cx_solution_14: '定量与定性研究',
  cx_solution_15: '服务设计',
  cx_solution_16: '营销战略',
  cx_solution_17: 'UX/UI测试',
  cx_solution_18: '受众洞察',
  cx_solution_19: '我们荣幸能为您的成功做出贡献',
  cx_solution_20:
    '我们根据您的业务目标和目的定制并结合工具与服务，以提供量身定制的结果',
  cx_solution_21: '全面的研究',
  cx_solution_22: '增强您的决策能力，为数据驱动的市场提供竞争优势。',
  cx_solution_23: '定性研究是收集和分析非数值数据，以理解概念、意见或经历',
  cx_solution_24:
    '定量研究方法是对通过民意调查、问卷和调查收集的数据进行客观测量和数值分析',
  cx_solution_25: '我们根据您的具体要求利用一组独特的工具',
  cx_solution_26: '工具',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    '计算机辅助网页访谈是我们工具箱中的一项重要工具，允许我们通过在线平台进行调查并收集数据，利用专用软件确保高效和准确的数据收集，以满足客户的市场研究需求',
  cx_solution_29: 'CATI',
  cx_solution_30:
    '计算机辅助电话访谈是我们用于通过电话进行调查并收集有价值数据的方法，利用专用软件简化过程并确保市场研究工作中的准确性',
  cx_solution_31: 'F2F',
  cx_solution_32:
    '面对面是我们方法的核心，促进与客户和消费者的直接互动和个性化接触，从而建立信任、理解和有效的沟通，这对建立持久的关系并推动商业成功至关重要',
  cx_solution_33: '桌面研究',
  cx_solution_34:
    '桌面研究包括全面的数据收集和分析，是我们研究过程的基础步骤，用于收集见解并为客户的战略决策提供信息',
  cx_solution_35: 'SWOT分析',
  cx_solution_36:
    'SWOT分析是一种战略评估工具，帮助我们的客户识别内部的优势与弱点，以及外部的机会与威胁，提供有价值的见解以指导决策并制定有效的商业战略',
  cx_solution_37: '民族志研究',
  cx_solution_38:
    '通过沉浸和观察人们和文化在其自然环境中的方式，常常能深入了解行为、信仰和社会动态',
  cx_solution_39: '深入访谈',
  cx_solution_40:
    '深入访谈是我们采用的一种定性研究方法，通过与参与者进行一对一的详细讨论，深入了解他们的观点、经历和意见，为客户的研究目标和决策过程提供丰富的见解和理解',
  cx_solution_41: '创意会议',
  cx_solution_42:
    '创意会议是我们组织的协作头脑风暴会议，汇集不同的观点和专业知识，生成创造性的想法和解决方案，以帮助客户应对挑战或抓住机会，推动创新并推动战略计划向前发展',
  cx_solution_43: '买家画像',
  cx_solution_44:
    '买家画像是我们根据研究和数据分析开发的详细客户档案，代表客户的目标客户群，帮助我们更好地理解他们的需求、偏好和行为，进而调整我们的策略和沟通，以有效地吸引和与之共鸣，最终推动商业成功',
  cx_solution_45: '神秘购物',
  cx_solution_46:
    '神秘购物是我们提供的一项战略服务，测量和监控客户与公司在预定场景中的互动',
  cx_solution_47: '陪同检查',
  cx_solution_48:
    '陪同检查是一种特殊的神秘购物形式，我们的评估员在客户的整个服务体验中陪同他们，提供关于客户旅程每个方面的全面洞察，使我们的客户能够深入了解他们的服务交付，并做出明智的改进，以提升整体客户满意度和忠诚度。',
  cx_solution_49: '反馈收集分析',
  cx_solution_50:
    '反馈收集分析是我们进行的一项关键过程，涉及从各种渠道（如调查、评论和社交媒体）系统地收集和分析客户反馈，使我们能够提取有价值的洞察，识别趋势，并为客户提供基于数据的建议，以改进他们的产品、服务和整体客户体验',
  cx_solution_51: '焦点小组',
  cx_solution_52:
    '焦點小組是我們組織的動態研究會議，將不同的參與者聚集在一起，深入討論特定主題或產品，使我們能夠收集定性見解，發現態度、偏好和看法，探索想法和概念，最終為客戶的決策和戰略制定過程提供信息',
  cx_solution_53: '20年打造卓越客户体验',
  cx_solution_54: '确保您的信息能够吸引并与您的受众产生共鸣。',
  cx_solution_55: '我们致力于交付超出您期望的结果',
  cx_solution_56: '我们发现有助于您增长的复杂解决方案',
  cx_solution_57: '通过我们的方法提升您的客户体验',
  cx_solution_58:
    '客户旅程映射是关于定义目标受众，了解他们的需求和环境，然后制定一个计划来提供引人入胜的体验',
  cx_solution_59: 'BHT',
  cx_solution_60:
    '品牌健康跟踪研究可以衡量您的品牌在知名度和使用度、品牌定位和品牌表现方面的表现',
  cx_solution_61: 'CSI',
  cx_solution_62:
    '客户满意度指数是一个分数，表示客户对公司产品/服务的满意程度。',
  cx_solution_63: '价格监测是收集、处理和分析竞争对手价格的过程',
  cx_solution_64: 'NPS',
  cx_solution_65:
    '净推荐值（Net Promoter Score）是客户体验度量的黄金标准，基于一个问题：您会推荐本组织/产品/服务吗？',
  cx_solution_66: 'HR研究',
  cx_solution_67:
    '人力资源研究用于评估人力资源实践和表现，并提供有关当前发展和管理的详细分析',
  cx_solution_68:
    '可用性测试是观察真实人群与网站、应用程序或其他产品的互动，观察他们的行为和反应',
  cx_solution_69: '其他',
  cx_solution_70: '专家为您的业务选择最佳方法',
  cx_solution_71: '让我们开始吧',
  cx_solution_72: '1 - 启动会议',
  cx_solution_73:
    '在启动会议中，我们确定并专注于关键任务。结果：理解目标、研究任务、截止日期、方法和责任领域。',
  cx_solution_74: '2 - 概念开发',
  cx_solution_75:
    '4Service分析部门汇总数据，协调报告结构。然后我们向客户展示结果，并附上见解和实施建议。',
  cx_solution_76: '3 - 现场工作',
  cx_solution_77:
    '为了进行研究，我们招募参与者，进行访谈和其他基本研究阶段。客户将收到转录的音频视频访谈和简洁的总结。',
  cx_solution_78: '4 - 分析',
  cx_solution_79:
    '4Service分析部门汇总数据，协调报告结构。然后我们向客户展示结果，并附上见解和实施建议。',
  cx_solution_80: '5 - 研讨会',
  cx_solution_81: '与客户进行关于实施计划的讨论',
  cx_solution_82: '了解更多关于我们的最佳实践',
  cx_solution_83:
    '客户旅程地图使我们能够快速检查所有沟通渠道，识别关键接触点的潜在缺陷，并全面了解可能偏离计划的领域。',
  cx_solution_84: '何时使用？',
  cx_solution_85: '根据关于受众群体的真实数据构建个性化广告活动',
  cx_solution_86: '找出不同目标受众细分的触发点并满足他们的需求',
  cx_solution_87: '精准地针对每个群体并获得最大转化',
  cx_solution_88: '陪同检查技术可以评估实现目标的最佳途径。',
  cx_solution_89: '在发布之前测试新网站或产品',
  cx_solution_90: '在实施更改之前检查已开发的流程',
  cx_solution_91: '评估网站或产品在销售下降中的表现',
  cx_solution_92: '根据客户偏好推出新产品',
  cx_solution_93: '研究竞争公司以确保在市场中占据领先地位',
  cx_solution_94: '我们提供360°全面视角的方法来创建以客户为导向的服务模型。',
  cx_solution_95: '员工培训与发展',
  cx_solution_96: '改进服务标准',
  cx_solution_97: '增加客户流量和销售',
  cx_solution_98: '为员工设定KPI和激励制度',
  cx_solution_99: '发现我们的成功案例',
  cx_solution_100: '汽车',
  cx_solution_101: '烟草',
  cx_solution_102: '零售',
  cx_solution_103: '定性阶段',
  cx_solution_104: '定量阶段（细分）',
  cx_solution_105: '焦点小组',
  cx_solution_106: '全球在线受众覆盖',
  cx_solution_107: '访谈过程中技术的混合使用',
  cx_solution_108: '仅开放性问题',
  cx_solution_109: '全天候响应支持',
  cx_solution_110: '保留重要细节及路径的真实画面',
  cx_solution_111: '市场研究',
  cx_solution_112: '公司和竞争对手的诊断',
  cx_solution_113: '更新的服务模型和新业务流程',
  cx_solution_114: '客户导向服务的推广',
  cx_solution_115: '变革的实施及对服务战略发展的控制',
  usage_attitude_1: '使用与态度（U&A）',
  usage_attitude_2: '全面了解目标受众如何感知、利用和参与您的品牌。',
  usage_attitude_3: '与专家对话',
  usage_attitude_4: '关于',
  usage_attitude_5: '<b>探索消费者</b>习惯，深入了解偏好和影响因素',
  usage_attitude_6: "<b>发现消费选择背后的'为什么'</b>，通过我们的详细分析",
  usage_attitude_7: '<b>了解客户如何</b>与您的产品互动，获取战略见解',
  usage_attitude_8:
    '<b>获取有关</b>消费者行为、习惯和偏好的洞察，以做出明智决策',
  usage_attitude_9: '經驗',
  usage_attitude_10:
    '拥有超过20年客户经验的4Service专家创造独特的解决方案，帮助您的业务增长',
  usage_attitude_11: '联系我们',
  usage_attitude_12: '为谁',
  usage_attitude_13: '谁从品牌使用与态度中受益？',
  usage_attitude_14: '各个行业和服务领域感兴趣的内容有：',
  usage_attitude_15: '<b>识别</b>客户需求和痛点',
  usage_attitude_16: '<b>识别</b>提升客户消费的机会',
  usage_attitude_17: '<b>开发</b>新的产品类别或营销策略',
  usage_attitude_18: '<b>深入了解</b>竞争环境',
  usage_attitude_19: '方法论根据客户的要求单独选择',
  usage_attitude_20:
    '<b>定性研究</b>涉及收集和分析非数值数据，以掌握概念、意见或经验。',
  usage_attitude_21:
    '<b>定量研究</b>方法包括通过调查、问卷和访谈客观地测量和数值化数据。',
  usage_attitude_22:
    '<b>收集数据后</b>，专家分析信息并得出结论，为您提供最佳建议。',
  usage_attitude_23: '谁需要',
  usage_attitude_24: '您的成功故事从这里开始',
  usage_attitude_25:
    '<b>您将收到一项研究</b>，其中包含有价值的见解，能够推动战略决策，确保行动基于对消费者行为的深刻理解。',
  usage_attitude_26:
    '<b>研究为优化</b>品牌策略提供坚实的基础，使其更贴近消费者的偏好和态度。',
  usage_attitude_27: '解决方案',
  usage_attitude_28: '通过我们的解决方案探索众多机会',
  usage_attitude_29: '类别内的产品偏好',
  usage_attitude_30:
    '识别消费者在不同类别（包括食品、饮料、服装、电子产品等）中的主要偏好。',
  usage_attitude_31: '消费/使用行为',
  usage_attitude_32:
    '分析特定产品/服务的消费或使用频率，并识别与其使用相关的场合和时刻。',
  usage_attitude_33: '购买行为',
  usage_attitude_34: '考察客户用于购买的渠道，并识别他们依赖的信息来源。',
  usage_attitude_35: '消费者动机和需求',
  usage_attitude_36:
    '考察影响消费的动机和障碍。评估影响消费者购买决策的因素。探索产品类别的感知，分析价格的感知。',
  usage_attitude_37: '我们的方法',
  usage_attitude_38: '品牌使用与态度研究',
  usage_attitude_39: '信息',
  usage_attitude_40: '采用定量与定性方法进行调查',
  usage_attitude_41: '开始',
  usage_attitude_42: '根据个人要求设定目标并确定方法',
  usage_attitude_43: '分析',
  usage_attitude_44: '我们的专家使用复杂的技术',
  usage_attitude_45: '我们根据您的特定需求使用一套独特的工具',
  usage_attitude_46: 'СATI',
  usage_attitude_47:
    '计算机辅助电话访谈是一种我们利用的方法，通过电话进行调查并收集宝贵数据，使用专门的软件简化过程，确保我们市场研究工作的准确性。',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    '计算机辅助网络访谈是我们工具库中的一个重要工具，允许我们通过在线平台进行调查并收集数据，借助专门的软件确保高效和准确的数据收集，以满足客户的市场研究需求。',
  usage_attitude_50: 'CAPI',
  usage_attitude_51:
    '计算机辅助个人访谈是我们用来优化数据收集过程的方法，使访谈更加顺畅，并确保为您的业务需求提供准确的深入结果。',
  usage_attitude_52: '焦点小组',
  usage_attitude_53:
    '焦点小组是我们组织的动态研究会议，汇集不同背景的参与者，深入讨论特定主题或产品，使我们能够收集定性洞察，发现态度、偏好和看法，并探索想法和概念，最终为客户的决策和战略发展提供信息。',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    '面对面的交流是我们方法的核心，促进了与客户和消费者的直接互动和个性化沟通，从而建立信任、理解和有效沟通，这对建立持久关系和推动业务成功至关重要。',
  usage_attitude_56: '人种学研究',
  usage_attitude_57:
    '通过沉浸式观察研究人们和文化，通常能深入了解行为、信仰和社会动态。',
  thank_you_page: '感谢您的时间！我们的经理将尽快与您联系。',
  back_main: '返回主页',
  opportunities_1: '了解更多我们的案例',
  opportunities_2: '发现',
  opportunities_3: '为您自己',
  opportunities_4: '机会',
  opportunities_5: '与4Service研究控股一起进行国际业务的机会',
  opportunities_6: '我们能用什么<span>产品</span>来增强您的业务？',
  opportunities_7: 'CX',
  opportunities_8: '为企业提供全面定制的解决方案',
  opportunities_9: '所有类型的神秘购物',
  opportunities_10:
    '我们实施神秘员工、神秘来电、奢华神秘购物、汽车神秘购物及其他类型',
  opportunities_11: '为企业定制的IT解决方案',
  opportunities_12: '拥有AI的自有IT解决方案，反馈分析平台和电话转录平台',
  opportunities_13: '市场研究',
  opportunities_14:
    '满足任何商业需求（品牌健康追踪、市场细分、NPS、eNPS、CJM、产品和广告测试等）',
  opportunities_15: '审计',
  opportunities_16:
    '我们进行各种服务审计，以及价格监控（离线、特定细分市场等）',
  opportunities_17: '服务设计',
  opportunities_18:
    '4Service - DesignThinkers Academy认证合作伙伴，为团队提供企业培训，并定期为企业开展工作坊',
  opportunities_19: '我们分享经验，但<span>尊重并不打扰</span>您的业务流程。',
  opportunities_20:
    '我们了解企业在发展过程中面临的困难，也知道如何克服这些障碍，这得益于我们的国际成功经验。您不仅获得经验，还获得资源。',
  opportunities_21: '我们邀请您合作！',
  opportunities_22: '我们为您的企业提供<span>合作伙伴计划</span>',
  opportunities_23:
    '在4Service这个国际公认的品牌下，您可以积极影响吸引新客户。',
  opportunities_24:
    '我们的合作伙伴会获得全面支持，包括培训、市场营销材料和运营支持。',
  opportunities_25: '与我们的合作将帮助您实现计划，而不打乱当前的业务流程。',
  opportunities_26: '我们的<span>办公室</span>',
  opportunities_27: '我们的客户',
  opportunities_28: '我们在CX领域有超过20年的经验',
  opportunities_29: '覆盖国家',
  opportunities_30: '千',
  opportunities_31: '独特项目',
  opportunities_32: '百万',
  opportunities_33: '神秘购物者的访问次数',
  opportunities_34: '位列欧洲TOP 10 CX机构',
  opportunities_35: '与4Service合作的机会',
  opportunities_36: '利润增加',
  opportunities_37: '您将获得国际订单的机会',
  opportunities_38: '独特的CX方法',
  opportunities_39: '来自拥有20年经验的专家支持',
  opportunities_40: '支持',
  opportunities_41: '我们的团队将支持您达成结果',
  opportunities_42: '销售',
  opportunities_43: '我们将帮助您建立销售系统',
  opportunities_44: '访问软件',
  opportunities_45: '您将获得所有认证IT工具的访问权限',
  opportunities_46: '培训',
  opportunities_47: '我们不仅会培训您的员工，还将继续提供咨询服务',
  opportunities_48: '谁适合合作伙伴关系？',
  opportunities_49: '您的企业是否与市场研究相关？',
  opportunities_50: '或者您计划尝试进入新领域',
  opportunities_51: '您是否计划：',
  opportunities_52: '实施创新',
  opportunities_53: '与国际品牌合作',
  opportunities_54: '扩展您的产品组合',
  opportunities_55: '加强您的市场地位？',
  opportunities_56: '培训您的员工',
  opportunities_57: '扩展您的业务',
  opportunities_58: '我们的资源 = 您的资源',
  opportunities_59: '凭借我们丰富的经验，我们已准备好在合作的第一阶段与您分享',
  opportunities_60: '数据分析：',
  opportunities_61: '国际分析团队',
  opportunities_62: '数据处理方法 - SPSS，Power BI',
  opportunities_63: '创新方法论和广泛的方法论',
  opportunities_64: '任何格式的报告',
  opportunities_65: '软件：',
  opportunities_66: '自有定制的IT开发',
  opportunities_67: 'DigSee Sure for CAPI',
  opportunities_68: 'SurveyMonkey for CAWI',
  opportunities_69: 'Shopmetrics',
  opportunities_70: 'VoIPTime（呼叫中心）',
  opportunities_71: '市场支持：',
  opportunities_72: '公关支持',
  opportunities_73: '推广和内容创作支持',
  opportunities_74: '设置潜在客户生成流程',
  opportunities_75: 'IT支持：',
  opportunities_76: '提供技术支持，包括安装、配置和使用我们的软件。',
  opportunities_77: '远程支持',
  opportunities_78: '安全控制',
  opportunities_79: '运营支持：',
  opportunities_80: '支持设置现场流程',
  opportunities_81: '反欺诈系统',
  opportunities_82: '任何复杂程度的招聘',
  opportunities_83: '项目和现场部门团队的运营管理',
  opportunities_84: '招聘质量控制',
  opportunities_85: 'UpWork',
  opportunities_86: '您将获得哪些奖励？',
  opportunities_87: '客户基础增长',
  opportunities_88: '市场形象提升',
  opportunities_89: '客户流失风险多样化',
  opportunities_90: '技术流程优化',
  opportunities_91: '国际经验',
  opportunities_92: '更多的现有客户销售',
  main_67:
    '竞争价格分析通过利用消费者支付意愿数据来识别关键特征，优化产品、提高利润并增强市场份额',
  main_68: '确保您的零售店符合品牌标准，评估物理属性及其对客户认知的影响',
  main_69: 'CX解决方案',
  main_70:
    '发现我们独特的360度CX解决方案：根据您的业务目标定制工具和服务，推动您的业务发展',
  main_71: '语音分析',
  main_72:
    '我们的先进语音分析工具将口语转录为文本，为企业提供宝贵的见解，以提升客户体验、监控绩效、确保合规并推动增长',
  parthership: '合作伙伴关系',
  banner_1: 'CX咨询和服务，提供您业务的360°视角',
  banner_2: '随时掌握最新研究！',
  banner_3: '我同意根据隐私政策处理个人数据',
  banner_4: '*选择市场',
  banner_5: '感谢订阅！',
  banner_6: '我们只会与您分享最有趣的内容！',
  banner_7: '提交',
  banner_8: '乌克兰',
  banner_9: '哈萨克斯坦',
  brand_awareness_1: '品牌知名度',
  brand_awareness_2: '和使用情况',
  brand_awareness_3: '挖掘品牌知名度和使用情况的潜力，以推动业务成功',
  brand_awareness_4: '与专家交谈',
  brand_awareness_5: '关于',
  brand_awareness_6: '<b>评估</b>您品牌的认知度和熟悉度',
  brand_awareness_7: '<b>确定</b>您的目标市场中品牌的知名度',
  brand_awareness_8: '<b>密切关注</b>客户保持率和忠诚度',
  brand_awareness_9: '<b>选择最佳策略</b>以改善必要的指标',
  brand_awareness_10: '通过我们的解决方案探索众多机会',
  brand_awareness_11: '品牌知名度',
  brand_awareness_12: '品牌使用',
  brand_awareness_13: '<b>发现</b>您的品牌在消费者细分群体中的认知度',
  brand_awareness_14: '<b>监控</b>您的受众的品牌知名度',
  brand_awareness_15: '<b>研究</b>消费者在购买时的自发想法',
  brand_awareness_16: '<b>了解</b>品牌知名度的主要来源',
  brand_awareness_17: '<b>考虑</b>有多少消费者体验过您品牌的产品或服务',
  brand_awareness_18: '<b>识别</b>在最初尝试后仍然坚持使用您品牌的消费者',
  brand_awareness_19: '<b>解锁</b>您的品牌被推荐的概率',
  brand_awareness_20: '<b>揭示</b>考虑将来使用您品牌的消费者百分比',
  brand_awareness_21: '谁受益于品牌知名度和使用情况？',
  brand_awareness_22: '推出新产品的企业',
  brand_awareness_23: '振兴已建立品牌的企业',
  brand_awareness_24: '任何希望了解并提升品牌认知和使用的企业',
  brand_awareness_25:
    '我们的研究方法提供有价值的见解，帮助优化您的品牌知名度和使用情况',
  brand_awareness_26: '该方法根据客户要求个别选择',
  brand_awareness_27: '品牌使用漏斗方法',
  brand_awareness_28: '试用率描述了意识到品牌并尝试其产品或服务的受众比例。',
  brand_awareness_29:
    '重复购买率表示熟悉品牌并尝试过其产品或服务的受众中，在过去12个月继续购买或使用该品牌的百分比。',
  brand_awareness_30:
    '保持率揭示了持续使用品牌产品或服务的个体比例，表明过去6个月内参与该产品或服务的比例。',
  brand_awareness_31:
    '保持率说明了在过去6个月使用过品牌产品/服务的客户，随着时间推移，继续选择并表现出忠诚度的百分比。',
  brand_awareness_32: '品牌知名度方法',
  brand_awareness_33: '心智领先（TOM）表示受访者自发提到的第一个品牌。',
  brand_awareness_34: '总自发知名度表示自发提到的品牌总数，包括TOM。',
  brand_awareness_35:
    '辅助知名度揭示了在提示下，您的品牌在用户中被多好地识别。',
  brand_awareness_36: '品牌属性表现图',
  brand_awareness_37:
    '此工具评估并直观地表示不同品牌属性的重要性，提供有关每个属性如何贡献品牌整体表现和消费者认知的见解。',
  brand_awareness_38: '通过我们的综合分析，揭示增强品牌影响力的关键。',
  brand_awareness_39: '品牌感知图',
  brand_awareness_40:
    '该工具提供竞争市场环境中消费者感知的视觉表现。这种方法对于清晰划定品牌之间的差异至关重要，强调关键市场属性。',
  brand_awareness_41: '它简化了观察和解读品牌与这些定义特征之间的关系。',
  brand_awareness_42:
    '特定品牌与某些属性的接近度表示它与这些特征的强关联性。同样，两个品牌之间的接近度表明它们的相似性，展示共享形象，并因此在同一市场细分中建立联系。',
  consumer_journey_map_1: '消费者旅程图',
  consumer_journey_map_2: '通过我们的消费者旅程图发现并克服业务中的障碍',
  consumer_journey_map_3: '受信任者',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5: '解锁CJM的潜力，优化您的消费者与品牌之间的互动',
  consumer_journey_map_6: '确定消费者在购买产品之前的步骤',
  consumer_journey_map_7: '从真实客户中获取洞察，而不是虚构的客户',
  consumer_journey_map_8: '全面了解您的客户体验',
  consumer_journey_map_9: '识别错失的机会，并与竞争对手进行基准对比',
  consumer_journey_map_10: '发现我们的CJM方法',
  consumer_journey_map_11:
    '我们通过各种渠道和特定的时间段，创建消费者与产品、服务、公司或品牌的互动路径。',
  consumer_journey_map_12:
    '我们概述了消费者在完成购买前的各个阶段、每个阶段客户的期望、情绪和动机。',
  consumer_journey_map_13: '与我们一起受益',
  consumer_journey_map_14:
    '我们提供一支经验丰富的专业团队，了解全球商业成功的复杂性',
  consumer_journey_map_15: '我们致力于提供超越您期望的成果',
  consumer_journey_map_16: '我们发现有助于您增长的复杂解决方案',
  consumer_journey_map_17: '我们专注于提供定制的CJM解决方案',
  consumer_journey_map_18: '预约咨询',
  consumer_journey_map_19: '数据驱动的决策',
  consumer_journey_map_20: '基于真实数据而非假设做出决策',
  consumer_journey_map_21: '优化您的CJM',
  consumer_journey_map_22:
    '通过在每个阶段满足客户的需求和期望，与客户建立更强的关系',
  consumer_journey_map_23: '引领潮流',
  consumer_journey_map_24: '与竞争对手进行比较，保持市场领先',
  consumer_journey_map_25: '推荐',
  consumer_journey_map_26:
    '实施我们的CJM建议，解锁成功，培养客户忠诚度，推动销售，并最大化您的商业潜力',
  consumer_journey_map_27: '通过我们的消费者旅程图发现真正的消费者旅程',
  consumer_journey_map_28: '拥有20多年经验的专家提供全面的研究',
  consumer_journey_map_29:
    '定性研究涉及收集和分析非数值数据，以把握概念、意见或经验。',
  consumer_journey_map_30:
    '定量研究方法涉及通过民意调查、问卷和调查收集数据，并进行客观测量和数值分析。',
  consumer_journey_map_31:
    '在收集数据后，专家分析信息并得出结论，提供最佳建议。',
  boarding_1: '客户旅程图',
  boarding_2:
    '客户旅程映射（CJM）是定义目标受众、了解他们的需求和环境，然后制定计划以提供吸引人的体验',
  boarding_3: '净推荐值',
  boarding_4:
    '净推荐值（NPS）是客户体验指标的黄金标准，基于一个问题：您有多大可能推荐本组织/产品/服务？',
  boarding_5: '品牌健康追踪',
  boarding_6:
    '品牌健康追踪（BHT）研究可以衡量您的品牌在知名度、使用情况、品牌定位和品牌表现方面的表现',
  boarding_7: '人力资源研究',
  boarding_8:
    '人力资源研究用于评估人力资源实践和表现，并提供当前发展和管理的详细分析',
  boarding_9: 'UX测试',
  boarding_10:
    '可用性（UX）测试是观察真实用户如何与网站、应用或其他产品互动，及其行为和反应',
  boarding_11: '客户满意度指数',
  boarding_12:
    '客户满意度衡量客户在购买产品或服务时，对您公司提供的产品或服务的期望满足程度',
  boarding_13: '广告测试',
  boarding_14: '广告活动是巨大的投资。确保您的广告具有强大的效果并带来最大回报',
  boarding_15: '现场审计/零售审计',
  boarding_16:
    '收集关于您的商店或品牌的详细数据，分析增长障碍并制定有效的策略来克服这些障碍',
  boarding_17: 'Play4Sales',
  boarding_18: '绩效管理软件。用于增加销售的游戏化应用程序',
  boarding_19: 'Voicer',
  boarding_20: '反馈管理系统。客户的声音在一个系统中。客户反馈管理系统',
  boarding_21: '定性研究',
  boarding_22: '定性研究是收集和分析非数值数据，以了解概念、意见或经验',
  boarding_23: '定量研究',
  boarding_24:
    '定量研究方法是通过民意调查、问卷和调查收集数据并进行客观测量和数值分析',
  boarding_25: '神秘购物',
  boarding_26:
    '神秘购物是一种市场研究技术，用于衡量和监控客户与公司或组织在预定义情境中的互动',
  boarding_27: 'Wantent',
  boarding_28: '一款基于人工智能的内容智能平台，提供观众的洞察',
  boarding_29: '价格监测',
  boarding_30: '价格监测是收集、处理和分析竞争对手价格的过程',
  boarding_31: '服务设计',
  boarding_32: '服务设计是通过与人们相处，了解使用产品或服务的需求和愿望',
  boarding_33: '汽车行业价格分析',
  boarding_34:
    '竞争价格分析通过利用消费者支付意愿数据来识别关键特征，优化产品、提高利润并增强市场份额',
  boarding_35: '设施检查审计',
  boarding_36: '确保您的零售店符合品牌标准，评估物理属性及其对客户认知的影响',
  boarding_37: 'CX解决方案',
  boarding_38:
    '发现我们独特的360度CX解决方案：根据您的业务目标定制工具和服务，推动您的业务发展',
  boarding_39: '语音分析',
  boarding_40:
    '我们的先进语音分析工具将口语转录为文本，为企业提供宝贵的见解，以提升客户体验、监控绩效、确保合规并推动增长',
  boarding_41: '使用与态度',
  boarding_42:
    '使用与态度是我们通过分析实际使用模式和心理态度，了解观众如何与您的品牌互动，从而制定量身定制的营销和产品策略',
  boarding_43: '品牌知名度与使用',
  boarding_44:
    '品牌知名度和使用涉及评估您的目标市场中的品牌识别度、熟悉度、互动频率和保持率，从而提升品牌的可见度和参与度',
  boarding_45: '品牌身份与定位',
  boarding_46:
    '品牌身份与定位是全面分析，揭示消费者认知、不同观众观点及您的品牌如何被感知的见解',
  boarding_47: '客户画像与细分',
  boarding_48:
    '客户画像与细分涉及根据共享特征将您的目标市场划分为不同的群体，从而制定与特定受众群体产生共鸣的个性化策略',
  boarding_49: '消费者旅程图',
  boarding_50:
    '消费者旅程图是消费者在与您的产品或品牌互动时所经历的各个阶段、接触点、情感和动机的视觉表现',
  boarding_51:
    '了解创新技术，这些技术支持我们提供可操作的洞察并推动您业务的影响力成果',
  boarding_52:
    '探索我们产品套件中的丰富数据驱动智能，为您的行业量身定制，使您能够做出明智的决策并保持领先',
  boarding_53:
    '深入市场趋势、消费者行为和竞争格局，通过我们的综合市场研究解决方案',
  boarding_54: '临时研究',
  boarding_55:
    '临时研究是一种定制方法，旨在解决特定问题，使用现有方法或新方法创建量身定制的解决方案。',
  boarding_56: '社会学研究',
  boarding_57:
    '社会学研究揭示人类行为和社会互动的模式，提供有价值的见解，以推动创新策略并与目标受众建立有意义的联系',
  not_found_1: '哎呀！我们找不到那个页面。',
  not_found_2: '为什么不查看我们的产品呢？',
  not_found_3: '预约咨询',
  customer_profiling_segmentation_1: '客户画像与市场细分',
  customer_profiling_segmentation_2:
    '我们将帮助您精准定位目标受众，使您的战略更加有效',
  customer_profiling_segmentation_3:
    '利用市场细分的力量，确保您的信息始终有效地传递到目标消费群体',
  customer_profiling_segmentation_4: '更深入了解消费者',
  customer_profiling_segmentation_5: '找到最适合您产品的目标受众',
  customer_profiling_segmentation_6: '探索吸引新的细分市场',
  customer_profiling_segmentation_7: '发现购买障碍',
  customer_profiling_segmentation_8: '我们专注于提供量身定制的细分解决方案',
  customer_profiling_segmentation_9: '独特的方法',
  customer_profiling_segmentation_10:
    '体验一项独特的、为您量身定制的细分解决方案',
  customer_profiling_segmentation_11: '目标人物',
  customer_profiling_segmentation_12:
    '基于深入的市场分析和全面的研究制定的目标人物',
  customer_profiling_segmentation_13: '新的细分市场',
  customer_profiling_segmentation_14:
    '识别最有价值的受众细分，并解锁定向营销的好处',
  customer_profiling_segmentation_15: '建议',
  customer_profiling_segmentation_16:
    '实施我们的建议，解锁成功，培养客户忠诚度，提升销售，并最大化您的商业潜力',
  customer_profiling_segmentation_17: '拥有20年以上经验的专家提供全面的研究',
  customer_profiling_segmentation_18:
    '定性研究涉及收集和分析非数字化数据，以理解概念、观点或经验。',
  customer_profiling_segmentation_19:
    '定量研究方法包括通过民意调查、问卷和调查来客观衡量和数字分析数据。',
  customer_profiling_segmentation_20:
    '收集数据后，专家会分析信息并得出结论，提供最佳建议。',
  customer_profiling_segmentation_21:
    '我们不仅进行测量，还为您提供一个包含明确逐步行动计划的方案',
  customer_profiling_segmentation_22: '我们的研究方法',
  customer_profiling_segmentation_23: '杰卡德指数',
  customer_profiling_segmentation_24:
    '当直接询问受访者时，他们对公司偏好的回答可能与他们的实际行为不一致。我们通过杰卡德统计分析代替直接询问，以理解公司属性与消费者选择之间的关系。',
  customer_profiling_segmentation_25: '驱动因素',
  customer_profiling_segmentation_26:
    '我们识别驱动因素（影响某一结果的因素），并根据其重要性将其分为关键、中等和不重要的驱动因素。',
  customer_profiling_segmentation_27: '细分',
  customer_profiling_segmentation_28: '您将获得带有明确客户选择特征的细分。',
  customer_profiling_segmentation_29: '我们的细分方法',
  customer_profiling_segmentation_30: '人口统计',
  customer_profiling_segmentation_31: '年龄',
  customer_profiling_segmentation_32: '性别',
  customer_profiling_segmentation_33: '收入',
  customer_profiling_segmentation_34:
    '它有助于根据特定群体量身定制产品、服务和营销，提高相关性和有效性',
  customer_profiling_segmentation_35: '心理图谱',
  customer_profiling_segmentation_36: '生活方式',
  customer_profiling_segmentation_37: '价值观',
  customer_profiling_segmentation_38: '行为',
  customer_profiling_segmentation_39:
    '它使个性化营销成为可能，与客户建立更深层次的联系，增加公司忠诚度和销售额',
  customer_profiling_segmentation_40: '行为',
  customer_profiling_segmentation_41: '行动',
  customer_profiling_segmentation_42: '动机',
  customer_profiling_segmentation_43: '购买频率',
  customer_profiling_segmentation_44:
    '它允许定向营销，提升客户满意度，增加客户保持率，并提高公司盈利能力',
  customer_profiling_segmentation_45: '地理位置',
  customer_profiling_segmentation_46: '地点',
  customer_profiling_segmentation_47:
    '它可以实现定向营销、量身定制的产品、有效分销，并增加公司在市场中的渗透率。',
  brands_identity_1: '品牌形象与定位',
  brands_identity_2:
    '通过深入分析，转变您的品牌，揭示消费者认知的洞察，并完善您的成功战略',
  brands_identity_3: '与专家对话',
  brands_identity_4: '<b>发现全面的</b>品牌形象分析',
  brands_identity_5: '<b>探索有关消费者认知的洞察</b>',
  brands_identity_6: '<b>了解不同的</b>目标受众观点',
  brands_identity_7:
    '<b>深入了解</b>消费者行为、习惯和偏好，为做出明智决策提供依据',
  brands_identity_8:
    '4Service 拥有超过20年客户经验的专家，创造独特的解决方案，帮助您发展业务',
  brands_identity_9:
    '<b>您将获得一个包含所有必要数据的研究包。</b> 它作为诊断工具，突出显示优势领域和可能需要关注的领域',
  brands_identity_10:
    '<b>我们的服务为企业提供必要的工具</b>，以做出明智的决策、完善战略，并在各自的行业中取得成功。',
  brands_identity_11: '提高您品牌在竞争市场中的地位',
  brands_identity_12: '努力增强市场存在感的企业',
  brands_identity_13: '寻求提升战略的企业',
  brands_identity_14: '品牌形象',
  brands_identity_15: '品牌定位',
  brands_identity_16: '<b>揭示您品牌的</b>在消费者群体中的认知。',
  brands_identity_17: '<b>识别赋予</b>您品牌和竞争对手的特质。',
  brands_identity_18: '<b>评估优缺点</b>以进行战略改进。',
  brands_identity_19: '<b>评估品牌形象与所推广价值的对齐度</b>。',
  brands_identity_20: '<b>评估品牌的</b>信任度。',
  brands_identity_21: '<b>探索品牌的原型</b>和象征性认知。',
  brands_identity_22: '<b>识别您品牌的</b>独特卖点和与竞争者的差异。',
  brands_identity_23: '<b>准确定位影响</b>消费者购买您产品/服务的关键属性。',
  brands_identity_24:
    '<b>确定您品牌在消费者心中的当前定位</b>，并识别需要传达的方面以吸引目标市场细分。',
  brands_identity_25: '该方法根据客户的要求单独选择',
  brands_identity_26: '品牌认知与使用',
  brands_identity_27:
    '评估品牌水平涉及衡量认知度和消费水平，作为评估的基本组成部分。',
  brands_identity_28: '品牌交付与信任',
  brands_identity_29:
    '这一指标衡量客户倡导（推荐）以及品牌持续履行承诺、创造积极客户体验并建立信任的能力。',
  brands_identity_30: '品牌形象表现',
  brands_identity_31:
    '评估品牌的表现涉及评估其与六个关键价值（3个理性和3个情感）的关联、在类别中的独特性，以及其在消费者中激发自豪感的能力。',
  brands_identity_32: '品牌健康分数',
  brands_identity_33:
    '品牌健康分数为您提供关于品牌在竞争环境中的表现的全面了解。',
  sociological_research_1: '社会学研究',
  sociological_research_2:
    '我们进行深入的社会现象和过程分析，帮助做出明智决策，通过独特的分析结论和建议。',
  sociological_research_3: '联系我们',
  sociological_research_4: '我们的客户',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'CATI是一种数据收集方法，使用计算机通过电话进行调查。CATI软件可以自动化数据收集、响应输入和调查管理的过程。使用CATI可以更容易地控制调查，快速分析和处理数据，并确保高水平的调查标准化。',
  sociological_research_7: 'CATI',
  sociological_research_8:
    'CAWI是一种数据收集方法，受访者通过网页界面填写问卷或回答问题，数据通过专用软件自动收集和处理。CAWI方法允许进行大规模调查，快速收集和分析数据。',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'CAPI是一种面对面调查的数据收集方法，研究人员使用平板电脑或手机输入受访者的回答，从而实现自动数据收集，减少输入错误，简化结果分析。',
  sociological_research_11: '我们的专家使用多种工具',
  sociological_research_12: '样本',
  sociological_research_13: '我们计算并应用任何复杂度的样本',
  sociological_research_14:
    '在我们的工作中，我们使用简单、系统、分层和集群样本',
  sociological_research_15:
    '对于全国代表性的面对面调查，我们使用分层多阶段抽样程序',
  sociological_research_16:
    '根据 settlements 的大小和类型进行区域选择，其数量按各地区的体量比例确定',
  sociological_research_17: '我们进行',
  sociological_research_18: '公众舆论研究',
  sociological_research_19: '社会经济研究',
  sociological_research_20: '桌面研究',
  sociological_research_21: '社会服务质量评估',
  sociological_research_22: '案例研究',
  sociological_research_23: '人力资源研究',
  sociological_research_24: '特定受众研究（包括弱势群体，如IDP、军人、青年等）',
  sociological_research_25: '我们与每个客户单独合作',
  sociological_research_26: '我们的客户：',
  sociological_research_27: '慈善基金会',
  sociological_research_28: '公共组织和工会',
  sociological_research_29: '国家结构',
  sociological_research_30: '我们的工作方法',
  sociological_research_31:
    '我们对工作采用科学的方法和对当前现实的深入理解，以及使用各种研究方法收集数据。',
  sociological_research_32:
    '我们邀请具有必要经验的高度专业化专家来解决具体请求，并拥有各领域的专家资源池。',
  sociological_research_33:
    '我们的内部分析部门根据任务的具体情况使用独特的工具分析收集到的数据。',
  sociological_research_34:
    '我们生成带有详细结论和建议的报告，考虑到目标受众的需求和期望。',
  sociological_research_35:
    '我们在实施建议过程中提供咨询和支持，帮助您做出积极的变化。',
  sociological_research_36: '我们关于电视的研究',
  sociological_research_37: '查看我们的报告',
  sociological_research_38:
    '我们的科学方法保证我们的客户在整个乌克兰和欧洲获得准确可靠的社会学数据，误差最小',
  sociological_research_39: '我们遵守所有社会学研究的伦理原则和规范。',
  sociological_research_40:
    '我们遵循乌克兰社会学协会的社会学家职业伦理规范和赫尔辛基研究伦理原则宣言。是ESOMAR、乌克兰营销协会、全乌克兰呼叫中心协会的成员。',
  sociological_research_41: '现场',
  sociological_research_42: '在线面板',
  sociological_research_43: '定期访谈员',
  sociological_research_44: '监督员',
  sociological_research_45: '现场质量控制',
  sociological_research_46: '100% GPS坐标固定（CAPI）',
  sociological_research_47: '问卷验证（CAWI、CAPI、CATI、PAPI）',
  sociological_research_48: '100%录音访谈（CAPI、CATI）',
  sociological_research_49: '我们使用授权软件：',
  sociological_research_50: 'SPSS用于分析统计数据，处理数据集',
  sociological_research_51:
    'DigSee Sure用于CAPI：问卷逻辑、地理定位、访谈录音、视频材料展示',
  sociological_research_52: 'SurveyMonkey用于CAWI：问卷逻辑、方便格式、可视化',
  sociological_research_53:
    'VoIPTime（呼叫中心）：任何复杂度的问卷编程，将音频录音传送给客户',
  sociological_research_54: '样本',
  sociological_research_55: '我们计算并应用任何复杂度的样本',
  sociological_research_56:
    '在我们的工作中，我们使用简单、系统、分层和集群样本',
  sociological_research_57:
    '对于全国代表性的面对面调查，我们使用分层多阶段抽样程序',
  sociological_research_58:
    '根据 settlements 的大小和类型进行区域选择，其数量按各地区的体量比例确定',
  sociological_research_59: '团队',
  sociological_research_60: '我们的社会学家是乌克兰社会学家协会的成员',
  sociological_research_61:
    '我们有12名全职分析师，具备量化和定性项目的经验，涵盖多个行业。',
  sociological_research_62:
    '我们有一支强大的分析团队，拥有超过10年的研究经验。我们的团队包括科学家、博士和MBI。',
  sociological_research_63: 'Iryna Maksymiuk',
  sociological_research_64:
    '研究部门负责人。拥有超过15年的市场研究经验，擅长各阶段的研究管理，分析报告和演示文稿的准备。',
  sociological_research_65: 'Andriy Biloskursky',
  sociological_research_66:
    '编程与数据处理部门负责人。20年的市场、社会学和市场研究经验。',
  sociological_research_67: 'Olena Somova',
  sociological_research_68:
    '编程专家，顿涅茨克国立大学社会学研究生。拥有5年市场研究经验。民主联盟女性委员会董事会成员，筹款部门负责人。',
  sociological_research_69: 'Anna Padalka',
  sociological_research_70:
    '研究部门社会学研究分部负责人，拥有13年国际和国内社会学和社会项目的经验。社会学博士，乌克兰呼叫中心协会研究委员会负责人。',
  ad_hoc_1: '临时研究',
  ad_hoc_2: '探索我们为独特案例设计的替代性研究',
  ad_hoc_3: '联系我们',
  ad_hoc_4: '我们的工作方法',
  ad_hoc_5:
    '我们的专家团队仔细分析收集的数据，为您提供有助于增长的复杂解决方案。',
  ad_hoc_6:
    '我们根据您的具体要求设计独特的研究，采用多种方法，包括问卷调查、访谈、小组讨论、数据分析等。',
  ad_hoc_7: '为什么选择临时研究？',
  ad_hoc_8: '灵活性',
  ad_hoc_9:
    '每个研究项目都是独一无二的。通过临时研究，我们可以根据需要灵活调整和发展独特的方法，确保您的洞察保持相关性和可操作性。',
  ad_hoc_10: '精准',
  ad_hoc_11:
    '通过根据您的独特需求量身定制我们的研究方法，我们提供精确和有针对性的结果，提供有价值的见解。',
  ad_hoc_12: '创新',
  ad_hoc_13:
    '我们在研究过程中拥抱创新和创意，探索新技术和方法，以发现隐藏的机会和挑战。',
  ad_hoc_14: '及时性',
  ad_hoc_15:
    '临时研究允许迅速实施，使您能够及时获取关键洞察，保持在行业中的领先地位。',
  ad_hoc_16: '我们的专长',
  ad_hoc_17:
    '4Service专家团队拥有超过20年的市场研究和客户体验经验，创造独特的解决方案，帮助您的业务增长。',
  ad_hoc_18: '我们根据您的具体需求使用独特的工具',
  ad_hoc_19: '没有一种方法适合您？',
  ad_hoc_20: '请求临时研究',
  ad_hoc_21: '针对特定问题定制',
  ad_hoc_22: '我们同时使用不同方法部分的组合以及完全新的方法',
  ad_hoc_23: '个性化方法',
  ad_hoc_24: '我们专门为您的问题量身定制解决方案',
  ad_hoc_25: '超越期望',
  ad_hoc_26: '我们提供可操作的计划和建议，帮助您的业务实现目标',
  ad_hoc_27: '您有非标准问题',
  ad_hoc_28: '没有任何方法适合您的问题',
  ad_hoc_29: '您希望同时请求不同的研究方法或其部分',
  ad_hoc_30: '谁会受益于临时研究？',
  sservice_design_1: '我们的一些客户',
  service_design_2: '服务设计',
  service_design_3: '将您的业务从产品和销售导向转变为服务和以人为本的导向',
  service_design_4: '与专家交谈',
  service_design_5: '免费学习！',
  service_design_6: '我们在服务设计库中收集了实用的有价值的信息',
  service_design_7:
    '该库包含每个步骤的详细描述、相关工具和技术、重要细节的提示，以及视频演示。',
  service_design_8: '进入库',
  service_design_9: '欢迎来到服务设计！',
  service_design_10:
    '服务设计旨在通过解决整个服务生态系统——人员、流程和接触点，来创造和改进服务，从而提高用户满意度和运营效率',
  service_design_11:
    '服务设计不仅仅是为什么你更喜欢某个咖啡馆而不是另一个。它还是你为什么一次又一次地回到这个地方，并告诉所有的朋友。',
  service_design_12: '企业如何受益于服务设计',
  service_design_13: '用户满意度',
  service_design_14: '创造无缝、个性化的体验，让用户感到愉悦。',
  service_design_15: '运营效率',
  service_design_16: '简化流程，降低成本，提高服务交付。',
  service_design_17: '品牌一致性',
  service_design_18: '确保所有接触点与品牌的价值观一致。',
  service_design_19: '适应变化',
  service_design_20: '设计能够随着需求变化而成长和发展的服务。',
  service_design_21: '忠诚度提升',
  service_design_22: '通过卓越的服务体验建立更强的客户关系并提升忠诚度。',
  service_design_23: '竞争优势',
  service_design_24: '通过独特、值得纪念的服务体验，在市场中脱颖而出。',
  service_design_25: '为什么',
  service_design_26: '为什么选择服务设计？',
  service_design_27:
    '它是一种文化、方法论和思维方式，帮助全球公司从以产品和销售为导向转变为专注于人类需求和问题。',
  service_design_28: '我们的服务',
  service_design_29: '客户服务设计',
  service_design_30:
    '我们开发并实施以客户为中心的项目，创造新产品或改善现有产品。我们还提供培训，帮助将来独立应对这些变化。',
  service_design_31: '员工服务设计',
  service_design_32:
    '一门实用课程，帮助开发和实施员工导向的流程、结构和公司内的变革。',
  service_design_33: '未来设计思维',
  service_design_34: '发展未来概念和公司战略，考虑不同的情景和可能的创新。',
  service_design_35: '商业中的创造力',
  service_design_36:
    '一门实用培训，帮助参与者运用创造力解决具体问题，并开发独特的市场解决方案。',
  service_design_37: '我们的工作坊',
  service_design_38: '我们为参与者提供实用的工作坊，并提供全球认可的证书',
  service_design_39: '创建超出预期的产品、服务和设施',
  service_design_40: '实施有效的业务流程',
  service_design_41: '协调公司员工与客户之间的关系',
  service_design_42: '日历',
  service_design_43: '即将推出',
  service_design_44: '了解我们过去的活动',
  service_design_45: '服务设计基础',
  service_design_46: '创建超出预期的产品、服务和设施',
  service_design_47: 'EX 服务设计',
  service_design_48: '创建超出预期的产品、服务和设施',
  service_design_49: '更多',
  service_design_50: '我们的工作方法',
  service_design_51: '4Service是您的以人为本的服务背后支柱！',
  service_design_52:
    '我们帮助公司开发必要的思维方式，并创建以人为本的内部环境。',
  service_design_53: '工具',
  service_design_54: '我们根据您的具体需求使用一套独特的技术和工具',
  service_design_55: '用户研究',
  service_design_56:
    '访谈、问卷调查、面对面、民族志研究，以了解用户的需求和行为',
  service_design_57: '角色模型',
  service_design_58: '代表不同用户类型的虚拟人物，指导设计决策',
  service_design_59: '客户旅程地图',
  service_design_60: '用户通过服务的体验的可视化表示，识别关键接触点和痛点',
  service_design_61: '头脑风暴会议',
  service_design_62: '与利益相关者合作的会议，生成创意和解决方案。',
  service_design_63: '原型制作',
  service_design_64: '创建服务的初步版本，以测试和完善概念',
  service_design_65: '服务蓝图',
  service_design_66: '展示不同服务组件和流程之间关系的详细图表',
  service_design_67: '合作伙伴',
  service_design_68: '4Service & DTA',
  service_design_69: '4Service是设计思维学院的官方独家代表',
  service_design_70: '作为我们合作的一部分，我们：',
  service_design_71:
    '<b>提供实践培训</b>，使用服务设计方法进行工作坊，由领先的专家主持；',
  service_design_72: '<b>培训认证</b>设计思维专家；',
  service_design_73:
    '<b>实施服务设计</b>项目，与国际主持人共同为许多公司提供服务。',
  service_design_74: '我们在以下地区建立了服务设计卓越中心：',
  service_design_75: '乌克兰',
  service_design_76: '哈萨克斯坦',
  service_design_77: '土耳其',
  service_design_78: '格鲁吉亚',
  service_design_79: '阿塞拜疆',
  service_design_80: '了解更多我们的案例',
  four_opinion_1: '4Service 调查',
  four_opinion_2: '参与在线调查赚钱，在家即可轻松赚取收益',
  four_opinion_3: '开始',
  four_opinion_4: '我们的优势',
  four_opinion_5: '值得信赖',
  four_opinion_6:
    '我们的社区在乌克兰已有超过 90,000 名消费者，在哈萨克斯坦有 100,000 名消费者',
  four_opinion_7: '合理回报您的时间',
  four_opinion_8: '我们珍惜您的时间，因此参与调查可获得礼品或现金奖励',
  four_opinion_9: '您的意见至关重要',
  four_opinion_10: '您的每条反馈都能帮助品牌更好地了解客户需求',
  four_opinion_11: '在 4Service 的 4Opinion 参与调查，在线赚钱或赢取奖品',
  four_opinion_12: '加入 4Opinion',
  four_opinion_13: '更多精彩故事尽在我们的频道',
  four_opinion_14: '了解更多（乌克兰）',
  four_opinion_15: '了解更多（哈萨克斯坦）',
  four_opinion_16: '为什么选择我们？',
  four_opinion_17: '4Service——专注于客户体验管理的国际研究控股公司',
  four_opinion_18: '我们跻身欧洲前十客户体验管理机构',
  four_opinion_19: '我们的使命是提升全球客户服务水平！',
  four_opinion_20: '如何通过在线调查赚钱？',
  four_opinion_21: '注册网站',
  four_opinion_22: '接收最新调查通知',
  four_opinion_23: '完成调查并赚取收益',
  four_opinion_24: '来自我们受访者的真实评价',
  four_opinion_25: '维塔利·科汉',
  four_opinion_26:
    '“完成调查后我都忘了，过了一段时间娜塔莉亚女士打电话告诉我中奖了。这就是我的奖品——三星 Galaxy M52 5G。非常感谢😁”',
  four_opinion_27: '维多利亚·波波夫斯卡娅',
  four_opinion_28: '“收到音箱，非常感谢你们公平、公正、有趣的抽奖活动。”',
  four_opinion_29: '尤利娅·奥列克桑德里夫娜',
  four_opinion_30:
    '“这可能是最近发生在我身上最不可思议的事情💕 不仅中奖了，而且还获得了超棒的奖品。没想到会这么好，太惊喜了。再次衷心感谢！”',
  four_opinion_31: '只有在这里，您才能赚取“真金白银”或赢取大奖',
  four_opinion_32: '在我们的频道关注最新调查',
  four_opinion_33: '进入频道',
  cati_1: 'CATI',
  cati_2: '高效的计算机电话调查',
  cati_3: '联系我们',
  cati_4: '我们的客户信赖我们',
  cati_5:
    '<b>CATI（计算机辅助电话采访）</b>是一种通过电话调查收集数据的方法，操作员使用专门的软件记录答案、确保问题逻辑性并分析结果。',
  cati_6: '4Service CATI 的主要优势：',
  cati_7: '<b>调查执行的高效性</b>',
  cati_8: '<b>数据质量高</b>',
  cati_9: '<b>问卷设置的灵活性</b>',
  cati_10: '<b>流程自动化</b>',
  cati_11: '具备大量<b>质量控制工具</b>',
  cati_12: '能够调查<b>难以接触的受访者类别</b>',
  cati_13: '<b>录音</b>所有<b>对话</b>，以便后续监听',
  cati_14: '能够快速<b>覆盖庞大的目标受众</b>',
  cati_15: '相比其他数据收集方法，该方法<b>更具经济效益</b>',
  cati_16: 'Solves',
  cati_17: '电话调查可解决哪些问题：',
  cati_18:
    '<span>市场细分研究。</span> 确定不同的消费者群体，以进行精准营销和制定有效的市场战略',
  cati_19:
    '<span>客户满意度评估。</span> 通过 SCI 和 NPS 指数衡量消费者对产品和服务的忠诚度',
  cati_20:
    '<span>NPS 管理与行动计划实施。</span> 通过电话调查，利用客服中心积极改善客户体验',
  cati_21:
    '<span>需求与市场趋势分析。</span> 研究产品和服务的受欢迎程度，确定有潜力的地区和发展方向',
  cati_22:
    '<span>竞争环境分析。</span> 评估品牌市场定位，与竞争对手比较，发现增长点',
  cati_23: 'For whom',
  cati_24: 'CATI 适用于：',
  cati_25: '希望推出新产品的公司',
  cati_26: '用于收集市场的最新数据，分析竞争环境并研究消费者偏好',
  cati_27: '与客户合作的品牌和公司',
  cati_28:
    '用于评估客户满意度（Customer Satisfaction、NPS）、分析需求并收集反馈',
  cati_29: '零售和电商',
  cati_30: '用于了解消费者行为、测试新产品、找出影响购买决策的因素',
  cati_31: '银行和金融机构',
  cati_32: '用于客户服务、公司信任度调查以及收集有关服务的反馈',
  cati_33: '社会组织',
  cati_34: '用于开展社会调查和分析公众舆论',
  cati_35: '政府机构和非政府组织',
  cati_36: '用于收集统计数据、研究社会问题和实施研究计划',
  cati_37: 'Quality',
  cati_38: '电话质量评估标准',
  cati_39: '基本沟通技能',
  cati_40: '遵守问候和通话结束标准，并能够切换至受访者舒适的语言',
  cati_41: '沟通风格',
  cati_42: '语言表达清晰、礼貌友好，并能建立与受访者的信任关系',
  cati_43: '对话管理',
  cati_44: '使用积极倾听技巧，保持受访者注意力，并高效引导对话',
  cati_45: '主题知识',
  cati_46: '深入理解调查主题，并能准确回答受访者的附加问题',
  cati_47: '问卷填写的准确性',
  cati_48: '准确录入答案，不歪曲信息，遵守指示，避免填写错误',
  cati_49: 'Why 4Service',
  cati_50: '为什么选择 4Service 的 CATI？',
  cati_51: 'CATI 适用于希望通过电话调查获取准确、结构化数据的公司',
  cati_52: '自有客服中心',
  cati_53: '我们已完成 70,000 多个有效电话，100% 满足客户需求',
  cati_54: '质量保证',
  cati_55: '100% 核实每个电话，确保数据真实可靠',
  cati_56: '个性化方案',
  cati_57: '根据个性化需求制定专属问卷',
  cati_58: '先进的软件支持',
  cati_59: '使用 VolPtime 处理任何复杂程度的 CATI 调查',
  cati_60: 'B2B 业务经验丰富',
  cati_61: '我们与法人实体合作，调查各行业和工业领域的高级专家',
  cati_62: '提交申请，我们将为您选择最佳解决方案！',
  cati_63: 'Technology',
  cati_64: '我们使用现代技术来分析结果并优化您的业务',
  cati_65: '功能：',
  cati_66: '<span>VolPtime</span> - 专业软件',
  cati_67: '组织入站（热线）/出站自动化线路',
  cati_68: '运营商统计数据，每种请求类型的统计数据，咨询时长',
  cati_69: '在线监控联系中心的工作情况',
  cati_70: '电话咨询的所有音频记录',
  cati_71: '远程和简便的软件配置',
  cati_72: '<span>Survey Monkey</span> - 专业问卷编程服务',
  cati_73: '编写不同复杂度的问卷',
  cati_74: '考虑研究的所有需求',
  cati_75: '简单、清晰且让受访者感到舒适',
  cati_76: 'Quality',
  cati_77: '客户对话质量评估',
  cati_78: '基于检查表的评分系统 ',
  cati_79: '服务质量通过特殊检查表进行测量，质量评估团队在报告期内给出平均分',
  cati_80: '标准合规目标指标',
  cati_81:
    '标准执行情况按既定级别进行评估，不得低于 90%。这些指标可根据员工经验进行调整',
  cati_82: '录音与实时通话监控',
  cati_83:
    '大约 40% 的通话通过录音监听，20% 通过实时监控，以便迅速应对潜在的标准违规情况',
  cati_84: 'Experts',
  cati_85: '我们拥有自己的联系中心',
  cati_86: '联系中心主管',
  cati_87: '人事招聘经理',
  cati_88: '乌克兰远程平台',
  cati_89: '哈萨克斯坦远程平台',
  cati_90: '技术协调员',
  cati_91: '项目经理',
  cati_92: '项目经理',
  cati_93: '培训与质量控制部门 ',
  cati_94: '60 名运营商（其中 20% 具备英语能力）',
  cati_95: '20 名运营商',
  cati_96: '质量控制部门主管 ',
  cati_97: '通话质量控制专家',
  cati_98: '培训讲师',
  main_73: '日记研究',
  main_74:
    '日记研究适用于探索长期体验和重复性活动。通过一段时间内在用户日常环境中的跟踪，深入了解其不断演变的用户体验和生活方式。',
  main_75: '员工体验 (EX)',
  main_76:
    '员工体验 (EX) 方法是一种战略方法，帮助组织设计更符合员工期望和业务目标的流程、文化和环境，从而提升员工福祉和企业绩效。',
  main_77: 'CATI',
  main_78: '计算机辅助电话访谈 (CATI)',
  main_79:
    'CATI 是一种灵活高效的研究方法，可根据多种业务需求（从客户满意度和员工参与度到市场和社会研究）收集高质量数据，确保获得准确、及时且可操作的洞察。',
  diary_study_1: '日记',
  diary_study_2: '研究',
  diary_study_3: '监测并收集关于用户体验和生活方式随时间变化的见解',
  diary_study_4: '与专家交流',
  diary_study_5: '联系我们',
  diary_study_6: '开始使用',
  diary_study_7:
    '申请日记研究，一次性获取定性和定量数据，深入了解消费者行为、市场趋势和品牌表现',
  diary_study_8: '生活方式和用户体验动态研究',
  diary_study_9:
    '日记研究提供深入的背景见解，了解用户如何互动，有助于识别其他方法无法察觉的模式和变化。',
  diary_study_10:
    '该方法可在自然环境中实时收集数据，大大提高了其可靠性和相关性',
  diary_study_11: '提供',
  diary_study_12: '我们提供定制化的日记研究',
  diary_study_13: '消费者参与',
  diary_study_14:
    '我们提供参与者组成的在线社区，他们在日常环境中记录自己的行为、活动和体验。',
  diary_study_15: '市场研究',
  diary_study_16:
    '我们的方法包括深入的市场研究，以提供符合客户特定需求的有价值数据。',
  diary_study_17: '品牌洞察',
  diary_study_18:
    '我们深入研究消费者的认知和行为，揭示有助于品牌战略制定的宝贵洞察。',
  diary_study_19: '专家',
  diary_study_20:
    '4Service 拥有超过 20 年客户体验经验的专家，提供助力业务增长的独特解决方案',
  diary_study_21: '项目管理',
  diary_study_22:
    '我们的团队提供全面的项目管理支持，确保每个环节都经过精心规划和执行，实现顺利的结果。',
  diary_study_23: '咨询服务',
  diary_study_24:
    '我们提供专家咨询，引导客户顺利完成项目各阶段，解决挑战并优化绩效。',
  diary_study_25: '质量保证',
  diary_study_26:
    '我们在每一个阶段都严格执行质量标准，确保项目达到并超出预期。',
  diary_study_27: '优势',
  diary_study_28: '与我们一起受益',
  diary_study_29: '<b>持续洞察</b>的无限来源',
  diary_study_30: '<b>每个阶段</b>的专家指导',
  diary_study_31: '<b>连接企业</b>与全球消费者',
  diary_study_32: '<b>便捷的数据收集</b>与深入反馈和回应',
  diary_study_33: '<b>项目各阶段</b>皆可访问的数据',
  diary_study_34: '<b>复杂的解决方案</b>助力您成长',
  diary_study_35: '研究',
  employee_experience_1: '员工体验',
  employee_experience_2: '企业的成功始于员工体验',
  employee_experience_3: '联系我们',
  employee_experience_4: '您的成功故事从这里开始',
  employee_experience_5:
    '4Service 拥有超过 20 年市场调研与客户体验经验的专家，创造助力业务发展的独特解决方案。',
  employee_experience_6:
    '我们的服务为企业提供必要工具，帮助做出明智决策，优化战略，并在各自领域取得成功。',
  employee_experience_7: '我们为您的具体需求选择最佳方法论',
  employee_experience_8: '员工旅程地图',
  employee_experience_9:
    '我们绘制从招聘到离职的整个员工生命周期，识别影响其体验的关键接触点，帮助识别改进点与提升满意度和参与度的机会',
  employee_experience_10: '带基准的员工旅程地图',
  employee_experience_11:
    '我们将员工旅程地图更进一步，将您的员工体验与行业基准进行比较，帮助简化内部流程、增强员工忠诚度并采纳最佳实践。',
  employee_experience_12: '雇主品牌健康研究',
  employee_experience_13:
    '我们评估员工如何从内部看待公司的品牌。强大的内部品牌可激发更高的员工动力和忠诚度，从而提升客户互动和企业声誉。',
  employee_experience_14: '员工净推荐值（eNPS）',
  employee_experience_15:
    '通过 eNPS，我们衡量员工推荐公司作为理想工作场所的可能性。这个简单而强大的指标揭示了整体满意度和忠诚度。',
  employee_experience_16: '员工承诺与满意度指数（ECSI）',
  employee_experience_17:
    '我们使用 ECSI 方法评估员工对其工作和公司的承诺和满意度水平，帮助了解其参与度并发现提升留存的机会。',
  employee_experience_18: '现任与前任员工的深度访谈',
  employee_experience_19:
    '我们与离职员工对话，找出离职原因并改善留任策略。通过与现任员工的沟通，找出优化服务、增强参与感和突破 KPI 障碍的方法。',
  employee_experience_20: 'UGC 分析',
  employee_experience_21:
    '用户生成内容（UGC）分析通过收集来自专业网站、社交媒体、论坛和视频平台的评论进行，帮助了解客户的真实期望与痛点，识别趋势和偏好变化，评估品牌与竞争者的优劣。',
  employee_experience_22: '神秘员工',
  employee_experience_23:
    '神秘员工从潜在雇员角度评估公司，审查内部流程是否有序、员工与候选人的互动表现，以及公司是否遵循其服务与沟通标准。',
  employee_experience_24: '激励访问',
  employee_experience_25:
    '激励访问奖励那些达到服务标准的员工，例如优质客户互动或成功的追加销售。神秘顾客识别出色员工，提升积极性并激励他人争取奖励与认可。',
  employee_experience_26: '服务设计',
  employee_experience_27:
    '我们利用服务设计识别业务挑战并挖掘创新解决方案，制定改善服务并满足客户或员工需求的战略。',
  employee_experience_28: '人力资源研究',
  employee_experience_29:
    'HR 研究帮助衡量员工在多大程度上与企业使命和价值观保持一致，并有效地向客户传达这些理念。',
  employee_experience_30: '与员工共同创造（焦点小组）',
  employee_experience_31:
    '通过直接让员工参与，我们开展共创焦点小组，收集反馈和见解。这一协作过程赋予员工塑造工作环境的权力，增强归属感和参与度。',
  employee_experience_32: '为什么要投资员工体验？',
  employee_experience_33: '降低员工流失率',
  employee_experience_34:
    '通过打造员工愿意留下并成长的工作场所，留住顶尖人才。',
  employee_experience_35: '提升员工忠诚度',
  employee_experience_36:
    '培养员工长期的承诺和奉献精神，减少昂贵的重新招聘成本。',
  employee_experience_37: '顺利适应变革',
  employee_experience_38: '减少对新规则和新举措的抵触，确保企业内部平稳过渡。',
  employee_experience_39: '提高生产力',
  employee_experience_40:
    '帮助您的团队适应新流程，并在各自岗位中发挥最佳表现。',
  employee_experience_41: '降低企业成本',
  employee_experience_42: '优化流程，节省成本并提升收益。',
  employee_experience_43: '卓越的员工体验推动企业成长',
  employee_experience_44:
    '员工体验（EX）涵盖员工在公司旅程中经历和感受到的一切。',
  employee_experience_45:
    '积极的员工体验促使员工与公司目标保持一致，激发动力并提升参与度。',
  employee_experience_46:
    '快乐且投入的员工提供卓越服务，从而带来客户满意与可持续增长。',
  employee_experience_47:
    '投资员工体验将带来连锁反应——更高留存率、更强生产力以及更优业务成果。',
  employee_experience_48: '您的员工体验 + 客户体验 将直接影响业务',
  employee_experience_49:
    '员工体验（EX）与客户体验（CX）密不可分。满意的员工更可能提供优质服务，提升客户满意度。通过我们的EX与CX整合方法，您可以将内部文化与卓越的客户服务对齐。',
  employee_experience_50:
    '通过整合员工与客户体验洞察，我们提供整体解决方案来提升两者。最终将打造更强大、更具凝聚力的企业文化，助力业务成功。',
  employee_experience_51: '快乐的雇主',
  employee_experience_52: '卓越的服务',
  employee_experience_53: '满意的客户',
  career_1: '成为一份子',
  career_2: '4Service',
  career_3: '我们期待您加入一个拥有无限职业成长机会的团队！',
  career_4: '查看职位空缺',
  career_5: '没有找到合适的职位？',
  career_6: '发送您的简历，我们会与您联系！',
  career_7: '发送简历',
  career_8: '注册表格',
  career_9: '*名字',
  career_10: '*姓氏',
  career_11: '*电子邮件',
  career_12: '*电话号码',
  career_13: '上传简历',
  career_14: '提交',
  career_15: '在 4Service 开启职业生涯',
  career_16: '主要职责：',
  career_17: '要求：',
  career_18: '我们提供：',
  career_19: '申请职位',
  career_20: '4Service — 国际研究控股公司',
  career_21: '自 2001 年运营',
  career_22: '关于我们',
  career_23: '我们发展企业文化',
  career_24: '我们的倡议',
  career_25: '我们致力于提升全球客户服务水平',
  career_26: '4Service 职位空缺',
  career_27: '您在 4Service 的职业机会',
  career_28:
    '通过每周 “Morning coffee” 心理健康支持会、团队建设活动及社会倡议保障心理健康',
  career_29:
    '与全球知名品牌合作的宝贵经验，例如：<span>Mercedes, Huawei, Philip Morris</span>',
  career_30: '通过讲座、培训和工作坊不断发展专业能力',
  career_31: '神秘顾客角色，影响知名品牌的发展',
  career_32:
    '无论身处世界何处均可合作，亦可选择远程或在以下办公室工作：<span>乌克兰、哈萨克斯坦、罗马尼亚、奥地利、阿塞拜疆、格鲁吉亚</span>',
  career_33: '通过参与活动、网络研讨会和社交活动发展个人品牌',
  career: '职业',
  shoppers_1: '平台',
  shoppers_2: '神秘顾客',
  shoppers_3: '加入我们',
  shoppers_4: '与 4Service 一起评估服务并获得收入',
  shoppers_5: '在 4Service 开启您的职业生涯',
  shoppers_6: '与有趣项目的合作正等着您',
  shoppers_7: '加入我们',
  shoppers_8: '加入我们的团队',
  shoppers_9: '了解更多 ›',
  shoppers_10: '督导',
  shoppers_11:
    '负责团队工作管理、计划、协调、质量控制及组织问题处理，确保任务完成的负责人。',
  shoppers_12: '神秘顾客',
  shoppers_13: '根据剧本访问商店、餐厅或其他机构，并报告体验的专家。',
  shoppers_14: '陈列员',
  shoppers_15: '根据品牌或公司标准在店内进行产品陈列的专业人员。',
  shoppers_16: '审计员',
  shoppers_17: '负责检查业务是否符合标准和要求的专业人员。',
  shoppers_18: '测试员',
  shoppers_19:
    '从客户角度测试服务、产品或流程的质量，并评估是否符合客户期望，同时发现潜在问题。',
  shoppers_20: '神秘申请者',
  shoppers_21:
    '分析客户服务流程，评估沟通质量、响应速度、流程便捷性及整体体验的专家。',
  shoppers_22: '促销员',
  shoppers_23:
    '通过产品演示、派发宣传资料、组织促销活动及回答客户问题来推广产品的专家。',
  shoppers_24: '访谈参与者',
  shoppers_25:
    '深度访谈参与者就某一主题、产品或服务，分享其想法、情感、动机或经验。',
  shoppers_26: '成为 4Service 的一员',
  shoppers_27: '我们在<b>全球范围</b>开展业务',
  shoppers_28: '我们的团队由 <b>1000+ 名专业人士</b>组成',
  shoppers_29: '我们在市场上已有 <b>20+ 年的成功经验</b>',
  shoppers_30: '指导手册',
  shoppers_31: '如何录制拜访音频',
  shoppers_32: '如何录制通话音频',
  shoppers_33: '无法将音频文件附加到问卷中？',
  shoppers_34: 'MSPA 神秘顾客专业标准与道德准则',
  shoppers_35: '常见问题',
  shoppers_36: '常见问题',
  shoppers_37: '每月可以赚多少钱？',
  shoppers_38: '我可以在我的城市多久执行一次任务？',
  shoppers_39: '如果地点关闭了该怎么办？这类访问的报酬是多少？',
  shoppers_40: '奖励是如何发放的？',
  shoppers_41: '奖励的发放时间是多久？',
  shoppers_42: '如有关于奖励的问题，我应联系谁？',
  shoppers_43: '您每月的奖励金额取决于您完成任务的频率。',
  shoppers_44:
    '一次任务的报酬可能从 40 格里夫纳（简单访问和电话）到 1200 格里夫纳（复杂和高级访问）不等。这取决于项目的复杂性和性质。',
  shoppers_45:
    '执行任务可以成为一个愉快的爱好，可与日常购物或与朋友一起去咖啡馆、比萨店和餐厅结合。',
  shoppers_46: '地点数量、项目规模；',
  shoppers_47: '轮换制度（每个地点最多每三个月访问一次）；',
  shoppers_48: '您的个人资料/技能与项目要求的匹配程度；',
  shoppers_49: '提交申请的及时性。',
  shoppers_50: '如果您检查的地点：',
  shoppers_51:
    '关闭 – 请拍摄入口门、关闭原因的告示（如有）、地点的营业时间或带地址的外观照片。',
  shoppers_52:
    '在指定地址不存在 – 请拍摄周边区域的视频，以及邻近建筑上有地址的正面照片。之后请联系您的协调员。',
  shoppers_53: '奖励将支付至“私人银行”银行卡（适用于自然人）。',
  shoppers_54: '您可以在您的个人账户中查看奖励的发放时间。',
  shoppers_55:
    '您还可以咨询您的协调员，或联系神秘顾客支持服务：ua@4service.support，请在邮件主题中注明项目名称和您的问题。',
  shoppers_56: '一般奖励发放时间显示在个人账户：“主页”中。',
  shoppers_57:
    '如果您没有收到奖励，并且已超过期限，请在个人账户中执行以下操作：',
  shoppers_58: '1. 检查所有个人信息是否填写完整，没有空白字段；',
  shoppers_59: '2. 确保您的银行卡信息填写正确，卡片仍在有效期内；',
  shoppers_60: '3. 所提供的银行卡为自然人账户；',
  shoppers_61: '4. 系统中的姓名与银行卡上的姓名完全一致（无拼写错误）。',
  shoppers_62:
    '如果您已确认信息无误，请联系神秘顾客支持服务：ua@4service.support，并在邮件主题中注明项目名称和问题内容。',
  shoppers_63: '神秘顾客 <br /> 专用应用程序',
  shoppers_64: '下载 4Shoppers 应用程序：',
  shoppers_65: '或',
  shoppers_66: '联系我们',
  shoppers_67: '支持聊天',
  shoppers_68: '电话：',
  shoppers_69: '邮箱：',
  shoppers_70: '还有问题？',
  shoppers_71: '外勤支持服务 <br />',
  shoppers_72: '联系我们',
  shoppers_73: '外勤支持服务',
  shoppers_74: '关于访问、付款及神秘顾客工作的其他问题',
  shoppers_75: '我同意根据',
  shoppers_76: '您的全名',
  shoppers_77: '问题描述',
  shoppers_78: '您的登录名',
  shoppers_79: '联系电话',
  shoppers_80: '付款期限',
  shoppers_81: '其他',
  shoppers_82: '联系我们',
  service_design_81: '前往资料库',
  service_design_82: '欢迎来到服务设计！',
  footer_btn_1: '成为神秘顾客',
  footer_btn_2: '参与有偿调查',
};
